export const pt = {
  // App level
  appSubtitle: "AI Agent Hub",

  // Authentication
  loginRequired: "Por favor, faça login para aceder ao painel",
  secureLogin: "Login Seguro",
  loginDescription:
    "Use as suas credenciais organizacionais para aceder ao sistema",
  loginWithSSO: "Login com SSO",
  loginHelp: "Será redirecionado para a página de login da sua organização",
  loading: "A carregar...",
  initializingApp: "A inicializar a aplicação...",
  redirecting: "A redirecionar...",
  processingLogin: "A processar o login...",
  pleaseWait: "Por favor aguarde enquanto completamos o seu login",
  uploadingFiles: "A carregar ficheiros...",
  processingFiles:
    "Por favor aguarde enquanto processamos os seus ficheiros...",
  loginSuccessful: "Login bem-sucedido!",
  redirectingToApp: "A redirecionar para a aplicação...",
  loginFailed: "Login falhou",
  loginError: "Ocorreu um erro durante o login",
  tryAgain: "Tentar novamente",
  logout: "Sair",
  loggingOut: "A sair...",

  // Access Control
  accessDenied: "Acesso Negado",
  adminAccessRequired:
    "Precisa de privilégios de administrador para aceder a esta secção.",
  goBack: "Voltar",

  // 404 Page
  pageNotFound: "Página Não Encontrada",
  pageNotFoundMessage:
    "A página que procura não existe ou não tem permissão para aceder.",
  goHome: "Ir para Início",
  noFilesYet: "Ainda não existem ficheiros",

  user: "Utilizador",
  regularUser: "Utilizador Regular",
  administrator: "Administrador",
  regularUserDescription:
    "Pode modificar configurações editáveis pelo utilizador (criatividade, atrasos de streaming, mensagens de erro)",
  administratorDescription:
    "Acesso completo a todas as configurações e definições do sistema",
  permissions: "Permissões",

  // Header
  changeRole: "Alterar Papel",

  // Homepage
  welcomeBack: "Bem-vindo de volta",
  homepageDescription: "Selecione uma secção para começar",
  dashboardDescription: "Visão geral do seu sistema AI Agent",
  superAdminDashboard: "Visão geral da plataforma e estatísticas de tenants",
  totalTenants: "Total de Tenants",
  activeTenants: "Tenants Ativos",
  totalAccountsSA: "Total de Contas",
  totalChatsSA: "Total de Chats",
  tenantBreakdown: "Distribuição de Tenants",
  usageOverview: "Visão de Utilização",
  usageOverviewMessages: "Utilização — Mensagens",
  usageOverviewDocuments: "Utilização — Documentos",
  usageOverviewCharacters: "Utilização — Caracteres em Documentos",
  withLimits: "Com Limites",
  noTenantsWithLimits: "Nenhum tenant com limites de utilização",
  recentTenants: "Tenants Recentes",
  noTenantsYet: "Nenhum tenant criado ainda",
  enabled: "Ativado",
  disabled: "Desativado",
  unlimited: "Ilimitado",
  totalFiles: "Total de Ficheiros",
  totalProducts: "Total de produtos",
  activeStoresLabel: "Lojas ativas",
  ingestionStatusLabel: "Estado da ingestão",
  filesByCollection: "Ficheiros por coleção",
  fileTypes: "Tipos de ficheiro",
  ingestion: "Ingestão",
  scheduler: "Scheduler",
  recentFiles: "Ficheiros Recentes",
  viewAll: "Ver Todos",

  // Main sections
  home: "Início",
  getStarted: "Começar",
  configurationManagement: "Gestão de Configurações",
  fileManagement: "Gestão de Ficheiros",
  configurationManagementDescription:
    "Gerir configurações do agente de IA, vector stores, workflows e prompts",
  fileManagementDescription: "Carregar e gerir ficheiros no vector store",
  generalInformation: "Informação Geral",
  campaigns: "Campanhas",
  products: "Produtos",
  internalProcedures: "Procedimentos Internos",
  internalChat: "Chat Interno",

  // Campaign dates and status
  startDate: "Disponível para AI desde",
  endDate: "Disponível para AI até",
  campaignStatus: "Estado",
  campaignActive: "Em curso",
  campaignPending: "Ainda não entrou em vigor",
  campaignExpired: "Expirada",
  selectStartDate: "Selecionar data de início",
  selectEndDate: "Selecionar data de fim",
  noEndDate: "Se não definir, o AI Agent pode usar o conteúdo indefinidamente",
  fileSettings: "Definições do ficheiro",
  from: "Desde",
  until: "Até",
  sourceLinkPlaceholder: "ex.: https://docs.exemplo.com/pagina",
  perFileDescription: "Cada ficheiro tem datas e links de fonte próprios.",
  datesUpdatedSuccessfully: "Datas atualizadas com sucesso",
  failedToUpdateDates: "Falha ao atualizar datas",
  startDateMustBeBeforeEndDate:
    "A data de início deve ser anterior à data de fim",
  campaignDates: "Datas de Conhecimento do AI Agent",
  campaignDatesDescription:
    "Configurar disponibilidade e fonte para {count} ficheiro{plural}.",
  startDateOptional:
    "Se não definir, o AI Agent pode usar o conteúdo imediatamente",
  sourceUrlInvalid: "URL de fonte inválido. Tem de começar por http:// ou https://.",
  sourceUrlTooLong: "URL de fonte demasiado longo (máximo 2048 caracteres).",
  sourceUrlsLabel: "Links de fonte",
  sourceUrlsHelper: "URLs para consultar mais informação sobre este ficheiro.",
  addLink: "Adicionar link",
  removeLink: "Remover link",
  sourceLinkNumbered: "Link de fonte {n} de {total}",
  removeLinkNumbered: "Remover link de fonte {n} de {total}",
  sourceColumnLink: "Link",
  sourceColumnName: "Nome",
  sourceLabelPlaceholder: "ex.: Regulamento",
  sourceLabelNumbered: "Nome do link de fonte {n} de {total}",
  sourceLabelTooLong: "Nome da fonte demasiado longo (máximo 80 caracteres).",
  sourceLabelsHint: "Com vários links, um nome curto ajuda o assistente a escolher o certo.",
  sourceUrlsTooMany: "Máximo de {max} links por ficheiro.",
  sameDatesForAllFiles: "Mesmas datas para todos os ficheiros",
  perFileSettings: "Definições por ficheiro",
  sourceLinkLabel: "Fonte",
  createdAt: "Criado em",
  createdBy: "Criado por",
  lastUpdatedBy: "Atualizado por",
  at: "em",
  lastUpdatedAt: "Última atualização",
  dateFilters: "Filtros de data (AI Agent)",

  // Toast messages
  loggedInAs: "Entrou como {role}",
  failedToLoadConfigurations: "Falha ao carregar configurações",
  loadingConfigurations: "A carregar configurações...",
  switchingChat: "A mudar de chat...",
  configurationUpdated: 'Configuração "{configType}" atualizada com sucesso',
  failedToUpdateConfiguration: "Falha ao atualizar configuração",
  failedToUpdate: "Falha ao atualizar {configType}: {message}",
  noPermissionToModify: "Não tem permissão para modificar esta configuração",

  // Common
  error: "Erro",
  success: "Sucesso",
  close: "Fechar",
  yes: "Sim",
  no: "Não",
  save: "Guardar",
  cancel: "Cancelar",
  edit: "Editar",
  saving: "A guardar...",
  delete: "Eliminar",
  deleting: "A eliminar...",

  // Language selector
  language: "Idioma",
  english: "English",
  portuguese: "Português",

  // Config management
  noConfigurationsAvailable: "Nenhuma configuração disponível para o seu papel",
  noConfigurationsFound: "Nenhuma configuração encontrada no sistema",
  regularUserAccessInfo:
    "Tem acesso a configurações editáveis pelo utilizador (criatividade, atrasos de streaming, mensagens de erro)",
  accessInformation: "Informações de Acesso",
  adminAccessInfo:
    "Tem acesso completo a todos os tipos de configuração. Pode modificar qualquer definição.",
  noPermissionToModifyConfig:
    "Não tem permissão para modificar esta configuração.",
  regularUserPermissionInfo:
    " Utilizadores regulares só podem modificar configurações editáveis pelo utilizador (criatividade, atrasos de streaming, mensagens de erro).",
  switchToAdminForFullAccess:
    " Mude para o papel de Administrador para acesso completo.",

  // Configuration types
  vectorStoreSettings: "Configurações do Vector Store",
  vectorStoreDescription: "Configurar vector store e definições RAG",
  userEditableSettings: "Configurações Editáveis pelo Utilizador",
  userEditableDescription:
    "Configurar criatividade, atrasos de streaming e mensagens de erro",
  genericTools: "Tools Genéricas",
  platformTools: "Tools de Plataforma",
  platformToolsNeedPlatform: "As tools de plataforma precisam de um platform type — define-o abaixo e grava para as ativar.",
  otherTools: "Outras",
  voiceToolsNeedChannel: "As tools de voz precisam do canal de voz ligado — liga-o e grava para as ativar.",
  workflowSettings: "Configurações do Workflow",
  workflowSettingsDescription: "Configurar parâmetros de conversa e workflow",
  promptTemplates: "Modelos de Prompt",
  promptTemplatesDescription: "Configurar modelos de prompt do agente IA",
  configurationSettings: "Definições de configuração",
  readOnly: "Apenas Leitura",
  fullAccess: "Acesso Completo",
  editSettings: "Editar Definições",
  notConfigured: "Por configurar",
  notConfiguredTitle: "Este chat não tem linha guardada para este tipo de configuração",
  notConfiguredDescription:
    "Não há nada guardado, por isso não há campos para mostrar. Criar escreve a linha para este chat, e os campos passam a aparecer com os valores por omissão da plataforma. Revê-os e grava antes de este chat servir tráfego.",
  createConfiguration: "Criar Configuração",
  creatingConfiguration: "A criar...",
  saveChanges: "Guardar Alterações",
  saved: "Guardado",
  unsavedChanges: "Tem alterações por guardar",
  discard: "Descartar",
  invalidJson: "JSON inválido",
  invalidJsonFile: "Ficheiro JSON inválido — esperado um objeto com pares chave-valor",
  characters: "caracteres",
  export: "Exportar",
  import: "Importar",

  // Config field groups
  groupCollection: "Coleção",
  groupProcessing: "Processamento",
  groupBehavior: "Comportamento",
  groupMessages: "Mensagens",
  groupLimits: "Limites",
  groupCore: "Prompts Principais",
  groupOther: "Outras Definições",
  groupRetrieval: "Definições de Pesquisa por Coleção",
  groupProductSettings: "Feed de Produtos",
  maxDocuments: "Max Documentos",
  similarityThreshold: "Limiar de Similaridade",

  // Config field descriptions
  fieldDescCollectionName: "Nome da coleção do vector store usada para RAG",
  fieldDescEmbeddingModel: "Modelo de IA usado para gerar embeddings de texto",
  fieldDescChunkSize: "Tamanho máximo dos blocos de texto para embedding",
  fieldDescChunkOverlap: "Sobreposição entre blocos de texto consecutivos",
  fieldDescSimilarityTopK: "Número de resultados similares a devolver",
  fieldDescCreativity: "Controla a criatividade das respostas (0 = preciso, 1 = criativo)",
  fieldDescStreamingDelay: "Atraso em ms entre segmentos de resposta em streaming",
  fieldDescInternalChat: "Ativar modo de chat interno para este agente",
  fieldDescErrorMessage: "Mensagem de erro personalizada mostrada quando algo falha",
  fieldDescWelcomeMessage: "Mensagem exibida quando um utilizador inicia uma conversa",
  fieldDescMaxTurns: "Número máximo de turnos numa conversa",
  fieldDescMaxTokens: "Tokens máximos permitidos por resposta do agente",
  fieldDescTimeout: "Timeout em segundos para geração de resposta",
  fieldDescSystemPrompt: "Prompt de sistema principal que define o comportamento do agente",
  fieldDescContextPrompt: "Contexto adicional injetado na conversa",

  // Role permissions
  allConfigurations: "Todas as Configurações",
  systemSettings: "Definições do Sistema",
  advancedOptions: "Opções Avançadas",

  // File management
  failedToLoadFiles: "Falha ao carregar ficheiros",

  // File upload
  upload: "Carregar",
  uploadFiles: "Carregar Ficheiros",
  uploadFilesDescription:
    "Carregar ficheiros para os adicionar ao vector store. Formatos suportados:",
  dragAndDrop: "Arraste e largue ficheiros aqui, ou",
  dropFilesHere: "Largue os ficheiros aqui",
  browseFiles: "procurar ficheiros",
  selectFiles: "Selecionar Ficheiros",
  selectMultipleFiles: "Pode selecionar múltiplos ficheiros",
  supportedFormats: "Formatos suportados:",
  uploading: "A carregar...",
  uploadingFile: "A carregar ficheiro...",
  uploadingAndProcessing:
    "A carregar e processar {fileName} ({current} de {total})",
  preparingNextFile: "A preparar para carregar o próximo ficheiro...",
  fileUploadedSuccessfully: "{fileName} carregado e processado com sucesso",
  uploadSuccess: "Ficheiros carregados com sucesso",
  uploadError: "Erro ao carregar ficheiros",
  uploadFailed: "Falha no carregamento",
  failedToUpload: "Falha ao carregar {fileName}: {error}",
  someFilesCouldNotBeUploaded:
    "Alguns ficheiros não puderam ser carregados: {errors}",
  fileTypeNotSupported: "Tipo de ficheiro {extension} não é suportado",
  fileSizeTooLarge: "Tamanho do ficheiro demasiado grande (máx. 50MB)",
  pdfPageLimitExceeded: "O PDF tem {totalPages} páginas, o máximo permitido é {maxPages}",
  allFilesUploadedSuccessfully:
    "Ficheiro carregado e processado com sucesso!",
  allFilesUploadedSuccessfullyPlural:
    "Todos os {count} ficheiros carregados e processados com sucesso!",
  uploadComplete:
    "Carregamento completo: {successful} com sucesso, {failed} falharam",
  uploadFailedCount:
    "Falha no carregamento: {count} ficheiro{plural} não puderam ser processados",
  queued: "Em fila",
  completed: "Concluído",
  failed: "Falhou",
  deleted: "Eliminado",
  rejected: "Rejeitado",
  deleteAndRejectComplete: "{deleted} eliminado{pluralD} e {rejected} rejeitado{plural} para esta loja.",
  deletingFiles:
    "A eliminar {fileName} ({current} de {total})",
  allFilesDeletedSuccessfully:
    "Todos os {count} ficheiro{plural} eliminados com sucesso!",
  deleteComplete: "Eliminação concluída: {successful} com sucesso, {failed} falharam",

  // File list
  fileList: "Lista de Ficheiros",
  noFiles: "Nenhum ficheiro disponível",
  uploadedFiles: "Ficheiros Carregados",
  noFilesUploaded: "Nenhum ficheiro carregado",
  noFilesOrFolders: "Sem ficheiros ou pastas",
  uploadFilesToSeeThem: "Carregue ficheiros para os ver listados aqui.",
  uploadFilesOrCreateFolder: "Carregue ficheiros ou crie uma pasta para começar.",
  readOnlyLocationHint: "Esta localização é só de leitura. Contacta o administrador se precisares de acesso.",
  filesCount: "{filtered} de {total} ficheiro{plural}",
  sort: "Ordenar",
  filters: "Filtros",
  selected: "{count} selecionado{plural}",
  deleteSelected: "Eliminar Selecionados",
  downloadAll: "Transferir Todos",
  downloadAllSuccess: "Transferidos com sucesso {count} ficheiro{plural}",
  downloadAllPartial: "Transferidos {successful} ficheiros, {failed} falharam",
  downloadZipSuccess:
    "Ficheiro ZIP criado com sucesso com {count} ficheiro{plural}",
  downloadZipPartial:
    "ZIP criado com {successful} ficheiros, {failed} falharam",
  downloadZipError: "Falha ao criar ficheiro ZIP",
  sortBy: "Ordenar por",
  name: "Nome",
  type: "Tipo",
  size: "Tamanho",
  date: "Data",
  searchByName: "Procurar por nome",
  enterFileName: "Pesquisar ficheiros...",
  fileType: "Tipo de ficheiro",
  allTypes: "Todos os tipos",
  allStatuses: "Todos os Estados",
  chat: "Chat",
  allChats: "Todos os chats",
  dateRange: "Intervalo de datas",
  clearAllFilters: "Limpar todos os filtros",
  selectAll: "Selecionar Todos",
  deselectAll: "Desselecionar Todos",
  deleteFile: "Eliminar ficheiro",
  downloadFile: "Transferir ficheiro",
  viewFile: "Ver ficheiro",
  deleteMultipleFiles: "Eliminar Múltiplos Ficheiros",
  deleteMultipleFilesConfirmation:
    "Tem a certeza de que pretende eliminar {count} ficheiro{plural}?",
  filesToBeDeleted: "Ficheiros a eliminar:",
  deleteActionWarning:
    "Esta ação não pode ser desfeita. Os ficheiros serão permanentemente removidos do vector store.",
  deleteCampaignWarning:
    "As campanhas da VTEX não se eliminam, rejeitam-se para esta loja. O ficheiro sai se mais nenhuma loja o publicar, e a rejeição desfaz-se no painel de sincronização.",
  deleteFiles: "Eliminar {count} Ficheiro{plural}",
  failedToDeleteFile: "Falha ao eliminar ficheiro: {error}",
  errorDeletingFile: "Erro ao eliminar ficheiro: {error}",
  deleteConfirmation: "Tem a certeza de que pretende eliminar este ficheiro?",
  fileDeleted: "Ficheiro eliminado com sucesso",

  // File viewer
  failedToLoadFileContent: "Falha ao carregar conteúdo do ficheiro",
  file: "ficheiro",
  download: "Transferir",
  preparingDownload: "A preparar transferência...",
  downloadingFiles: "A transferir ficheiros",
  creatingZip: "A criar ficheiro ZIP...",
  errorLoadingFile: "Erro ao carregar ficheiro",
  page: "página{plural}",
  scrollToNavigate: "Rolar para navegar",
  zoom: "Zoom",
  failedToLoadPDF: "Falha ao carregar PDF",

  // File editing
  fileSaved: "Ficheiro guardado com sucesso",
  failedToSaveFile: "Falha ao guardar ficheiro",
  editFile: "Editar Ficheiro",
  editingFile: "A editar {fileName}",
  unauthorizedToEditFile: "Não está autorizado a editar este ficheiro",
  permissionDeniedToEditFile: "Permissão negada para editar este ficheiro",
  fileNotFoundForEdit: "Ficheiro não encontrado para edição",
  fileTooLargeToEdit: "Ficheiro demasiado grande para editar",
  serverErrorWhileSaving: "Erro do servidor ao guardar o ficheiro",
  networkErrorWhileSaving: "Erro de rede ao guardar o ficheiro",
  deleteFileConfirmation: "Tem a certeza de que pretende eliminar {fileName}?",
  fileToBeDeleted: "Ficheiro a eliminar",

  // Footer
  quickLinks: "Links Rápidos",
  contactAndInfo: "Contacto & Informação",
  allRightsReserved: "Todos os direitos reservados.",

  // Products Management
  productsManagement: "Gestão de Produtos",
  productsManagementDescription: "Gerir ingestão de produtos e scheduler",
  clearCache: "Limpar Cache",
  clearCacheDescription: "Limpar todos os dados em cache",
  clearProductsCache: "Cache de Produtos",
  clearProductsCacheDescription: "Limpar cache específico de produtos",
  clearGeneralInformationCache: "Cache de Informação Geral",
  clearGeneralInformationCacheDescription:
    "Limpar cache específico de informação geral",
  clearCampaignsCache: "Cache de Campanhas",
  clearCampaignsCacheDescription: "Limpar cache específico de campanhas",
  clearInternalProceduresCache: "Cache de Procedimentos Internos",
  clearInternalProceduresCacheDescription: "Limpar cache específico de procedimentos internos",
  clearButton: "Limpar Cache",
  clearButtonLoading: "A limpar...",
  confirmClearCache: "Confirmar Limpeza",
  confirmClearCacheMessage:
    "Tem a certeza de que pretende limpar o cache de {cacheType}?",
  cacheClearedSuccess: "Cache de {cacheType} limpo com sucesso!",
  cacheActions: "Ações de Cache do Chat",
  cacheActionsDescription: "Limpar cache específico por tipo de conteúdo",
  runIngestion: "Executar Ingestão",
  runIngestionDescription:
    "Executar manualmente a ingestão de produtos do feed",
  startScheduler: "Iniciar Scheduler",
  startSchedulerDescription: "Iniciar o scheduler de ingestão de produtos",
  stopScheduler: "Parar Scheduler",
  stopSchedulerDescription: "Parar o scheduler de ingestão de produtos",
  schedulerStatus: "Estado do Scheduler",
  schedulerRunning: "Scheduler em Execução",
  productIngestionJob: "Tarefa de Ingestão de Produtos",
  running: "Em Execução",
  stopped: "Parado",
  cacheClearedSuccessfully: "Cache limpo com sucesso",
  ingestionStartedSuccessfully:
    "Ingestão de produtos iniciada em segundo plano",
  schedulerStartedSuccessfully:
    "Scheduler de ingestão de produtos iniciado com sucesso",
  schedulerStoppedSuccessfully:
    "Scheduler de ingestão de produtos parado com sucesso",
  failedToClearCache: "Falha ao limpar cache",
  failedToStartIngestion: "Falha ao iniciar ingestão de produtos",
  failedToStartScheduler: "Falha ao iniciar scheduler",
  failedToStopScheduler: "Falha ao parar scheduler",
  failedToFetchSchedulerStatus: "Falha ao obter estado do scheduler",
  connectionError: "Erro de Ligação",
  status: "Estado",
  intervalMinutes: "Intervalo",
  intervalHiddenByDailyTimesMode:
    "O horário corre a horas fixas, portanto este intervalo não é usado. Continua guardado e continua a ser gravado; volta a pôr o modo em 'interval' para o editar. Continua a ser validado, no entanto: um valor de 0 ou menos recusa o horário.",
  dailyTimesHiddenByIntervalMode:
    "O horário corre por intervalo, portanto as horas fixas não são usadas. Continuam guardadas e continuam a ser gravadas; põe o modo em 'daily_times' para as editar.",
  dailyTimes: "Horas fixas",
  atTimes: "Às",
  minutes: "minutos",
  nextRunTime: "Próxima Execução",
  nextRun: "Próxima Execução",
  lastIngestion: "Última Ingestão",
  ingestionStatus: "Estado da Ingestão",
  manualIngestionStatus: "Estado da Ingestão Manual",
  manualIngestionDescription:
    "Mostra o estado das ingestões acionadas manualmente apenas",
  startedAt: "Iniciado em",
  completedAt: "Concluído em",
  noIngestionRunning: "Nenhuma ingestão em execução",
  noManualIngestion: "Nenhuma ingestão manual em execução",
  clickRunToStart:
    "Clique em 'Executar Ingestão' para iniciar o processamento de produtos",

  // Conversations
  conversations: "Conversas",
  conversationsEmpty: "Ainda não há conversas",
  conversationsEmptyHint:
    "As conversas aparecem aqui quando um chat corre em modo kodly_direct",
  conversationsLoadFailed: "Não foi possível carregar as conversas",
  conversationsAnonymous: "Anónimo",
  conversationsStatusOpen: "Aberta",
  conversationsStatusResolved: "Resolvida",
  conversationsStatusHandedOff: "Transferida",
  conversationsBot: "Bot",
  conversationsBotTitle: "Começada por um programa automático (um crawler ou um teste), fora das contagens da analytics",
  conversationsAll: "Todas",
  conversationsAllChats: "Todos os chats",
  conversationsBack: "Voltar às conversas",
  conversationsTranscriptLabel: "Transcrição da conversa",
  conversationsNotFound: "Conversa não encontrada",
  conversationsDetailFailed: "Não foi possível carregar a conversa",
  conversationsRoleUser: "Cliente",
  conversationsRoleAssistant: "Agente",
  conversationsRoleSystem: "Sistema",
  conversationsRoleTool: "Ferramenta",
  conversationsRoleOperator: "Operador",
  // O divisor onde a conversa passou a um operador no Chatwoot.
  conversationsHandedOffTo: "Transferida para {name} às {time}",
  conversationsHandedOffToSomeone: "Transferida para um operador às {time}",
  conversationsPageMarker: "Na página {path}",
  // Por baixo de uma mensagem do cliente que a ponte nao entregou ao operador.
  conversationsBridgeLate: "Ainda não chegou ao operador",
  conversationsBridgeRejected: "Não chegou ao operador",
  conversationsBridgeUncertain: "Pode não ter chegado ao operador",
  // No fundo de uma conversa que passou a um operador.
  conversationsOpenInChatwoot: "Abrir no Chatwoot",
  conversationsOpensInNewTab: "(abre num separador novo)",
  conversationsCount: "{count} conversa{plural}",
  conversationsNoMessages: "Sem mensagens",
  conversationsPickOne: "Escolha uma conversa",
  conversationsPickOneHint: "A transcrição aparece aqui",
  conversationsStartedAgo: "Começou {when}",
  conversationsKindImage: "Imagem",
  conversationsKindVoice: "Mensagem de voz",
  conversationsKindDocument: "Documento",
  conversationsAttachmentDownload: "Descarregar",
  conversationsAttachmentLoading: "A carregar",
  conversationsAttachmentFailed: "Não foi possível carregar. Tentar outra vez",
  // O cabecalho da lista e os seus filtros. Os botoes de estado reutilizam as
  // chaves de estado acima; estas sao o cromo a volta deles.
  conversationsFilters: "Filtros",
  conversationsFiltersActive: "{count} filtro{plural} ativo{plural}",
  conversationsClearFilters: "Limpar filtros",
  conversationsStatusGroup: "Filtrar por estado",
  conversationsPeriod: "Período",
  conversationsPeriodAny: "Sempre",
  conversationsPeriodLast7: "Últimos 7 dias",
  conversationsPeriodLast30: "Últimos 30 dias",
  conversationsPeriodCustom: "Escolher datas",
  conversationsPeriodRange: "{from} a {to}",
  conversationsChat: "Chat",
  conversationsRemoveFilter: "Remover filtro {label}",
  // Os filtros do CSAT (D16 do plano do CSAT na pagina). O operador e o "so com o assistente"
  // so chegam pela ligacao da pagina de analise, e mostram-se so como pastilhas.
  conversationsCsatFilter: "Avaliação",
  conversationsCsatAny: "Qualquer",
  conversationsCsatRated: "Com avaliação",
  conversationsCsatCommented: "Só com comentário",
  conversationsPeriodByStart: "Iniciadas",
  conversationsPeriodByClose: "Fechadas",
  conversationsPeriodBy: "Contar pelo início ou pelo fecho",
  conversationsChipClosed: "Fechadas: {period}",
  conversationsChipOperator: "Operador: {name}",
  conversationsChipOperatorUnnamed: "Operador do CSAT",
  conversationsChipVoice: "Com mensagem de voz",
  conversationsChipAssistantOnly: "Só com o assistente",
  // Os botoes de filtro nomeiam o CONJUNTO, as chaves de estado nomeiam uma
  // conversa: "Abertas" ao lado de "Todas", "Aberta" na pastilha.
  conversationsFilterOpen: "Abertas",
  conversationsFilterResolved: "Resolvidas",
  conversationsFilterHandedOff: "Transferidas",
  conversationsEmptyFiltered: "Experimente outro estado ou limpe os filtros",
  conversationsRetry: "Tentar novamente",
  // O aviso de que o agente esta a escrever, por baixo do ultimo turno.
  conversationsAgentTyping: "O agente está a escrever",
  // Separadores de dia na transcricao. Os dias mais antigos vem do Intl; estes
  // dois sao nossos para a maiuscula ser nossa.
  conversationsToday: "Hoje",
  conversationsYesterday: "Ontem",
  // A coluna do contacto mostra-se e esconde-se a partir do cabecalho da
  // transcricao.
  conversationsShowContact: "Mostrar contacto",
  conversationsHideContact: "Ocultar contacto",
  // Terceira coluna: quem e o contacto por tras da conversa. Cromo de
  // operador, portanto segue a lingua do backoffice e nao a do widget.
  conversationsContactPanel: "Contacto",
  conversationsContactEmail: "Email",
  conversationsContactPhone: "Telefone",
  conversationsContactIdentifier: "Identificador",
  conversationsContactFirstSeen: "Visto pela primeira vez",
  conversationsContactHistory: "Conversas anteriores",
  conversationsContactFirstConversation: "Primeira conversa deste contacto",
  conversationsContactHistoryMore: "Este contacto tem mais conversas além destas {count}",
  conversationsContactHistoryFailed: "Não foi possível carregar as conversas anteriores",
  // Atributos de contexto: o que o browser do cliente mandou naquele turno, e
  // nao propriedades guardadas no contacto. O titulo tem de dizer quando, senao
  // le-se como um registo permanente que a plataforma nunca guarda. Os rotulos
  // das chaves saem da propria chave (utils/contextAttributes.js). So o que a
  // plataforma escreve tem rotulo traduzido: a pagina, o dispositivo, as linguas,
  // o carrinho, os detalhes tecnicos (IP, User-Agent) e o nome do perfil (Nome).
  conversationsContextHeading: "Contexto da última mensagem",
  conversationsCustomerProfileHeading: "Perfil do cliente (informação do cookie)",
  conversationsContextPage: "Página",
  conversationsContextItemsOne: "1 item",
  conversationsContextItems: "{count} itens",
  conversationsContextFieldsOne: "1 campo",
  conversationsContextFields: "{count} campos",
  conversationsContextDevice: "Dispositivo",
  conversationsContextLanguages: "Línguas",
  conversationsContextPageLanguage: "Página em {language}",
  conversationsContextBrowserLanguage: "Browser em {language}",
  conversationsContextTechnical: "Detalhes técnicos",
  conversationsContextCopyUserAgent: "Copiar User-Agent",
  conversationsContextCopied: "Copiado",
  conversationsCartItemsOne: "1 artigo",
  conversationsCartItems: "{count} artigos",
  conversationsCartEmpty: "Carrinho vazio",
  conversationsCartItemFallback: "Artigo {id}",
  conversationsCartToOffer: "Por oferecer: {list}",
  conversationsCartShowOthers: "Mostrar os outros {count}",
  conversationsCartUnits: "{qty} unidades",
  conversationsCart: "Carrinho",
  conversationsProfileName: "Nome",
  conversationsContextIp: "IP",
  conversationsContextCopyIp: "Copiar IP",
  conversationsContextUserAgentLabel: "User-Agent",
  conversationsDeviceMobile: "Telemóvel",
  conversationsDeviceTablet: "Tablet",
  conversationsDeviceDesktop: "Computador",
  conversationsDeviceOther: "Outro dispositivo",
  conversationsContextMore: "mais {count}",
  // Cartao da avaliacao do cliente (CSAT) no fim de uma conversa fechada.
  conversationsCsatTitle: "Avaliação do cliente",
  conversationsCsatHandledBy: "Atendido por {name}",
  conversationsCsatStarsLabel: "{n} de 5 estrelas",
  // Cartoes de produto na transcricao (portados do widget, texto identico ao
  // que o cliente viu, menos o botao de adicionar ao carrinho).
  productCardViewProduct: "Ver produto",
  productCardSizesLabel: "T:",
  productCardPrevious: "Produto anterior",
  productCardNext: "Próximo produto",
  productCardCarouselLabel: "Produtos recomendados",
  productCardRecommendedPriceLabel: "PVPR",
  productCardPriceBadgeOverRecommended: "sobre PVPR",
  productCardPriceBadgeDirect: "DIRETO",
  productCardDeliveryBusinessDays: "Entrega em {min} a {max} dias úteis",
  productCardDeliveryBusinessDaysExact: "Entrega em {days} dias úteis",
  productCardDeliveryBusinessDaysOne: "Entrega em 1 dia útil",
  productCardDeliveryUpTo: "Entrega em até {max} dias",
  productCardDeliveryUpToOne: "Entrega em até 1 dia",
  productCardAvailabilityTemporarilyUnavailable:
    "Temporariamente indisponível",
  productCardAvailabilityPreorder: "Entrega na data de lançamento",
  productCardPriceInfo: "Informação sobre preços",

  // Store Locations Management
  totalStores: "Total de Lojas",
  activeStores: "Ativas",
  inactiveStores: "Inativas",
  storeLocations: "Lojas",
  storeLocationsManagement: "Gestão de Lojas",
  storeLocationsManagementDescription: "Importar e gerir localizações de lojas",
  storeLocationsDescription:
    "Importar localizações de lojas a partir de um ficheiro JSON",
  storeLocationsDragDrop:
    "Arraste e solte um ficheiro JSON aqui, ou clique para selecionar",
  storeLocationsSelectFile: "Selecionar Ficheiro JSON",
  storeLocationsUploading: "A carregar e importar lojas...",
  storeLocationsFileFormat:
    "Formato do ficheiro: Array JSON com objetos de loja. Todos os campos (id, nome, morada, cod_postal, latitude, longitude) são obrigatórios.",
  storeLocationsFieldId: "ID da loja (obrigatório)",
  storeLocationsFieldNome: "Nome da loja (obrigatório)",
  storeLocationsFieldMorada: "Morada (obrigatório)",
  storeLocationsFieldCodPostal: "Código postal (obrigatório)",
  storeLocationsFieldLatitude: "Latitude (obrigatório)",
  storeLocationsFieldLongitude: "Longitude (obrigatório)",
  storeLocationsInvalidFileType: "O ficheiro deve ser um ficheiro JSON",
  storeLocationsFileTooLarge: "O tamanho do ficheiro deve ser inferior a 10MB",
  storeLocationsImportSuccess: "Lojas importadas com sucesso",
  storeLocationsImportSuccessWithCount: "{count} lojas importadas com sucesso",
  storeLocationsImportFailed: "Falha ao importar lojas",
  storeLocationsImportError: "Erro ao importar localizações de lojas",
  storeLocationsImportedCount: "{count} lojas importadas",
  storeLocationsInstructions: "Instruções",
  storeLocationsInstructions1:
    "1. Prepare um ficheiro JSON com um array de objetos de loja",
  storeLocationsInstructions2:
    "2. Cada objeto de loja deve conter os seguintes campos:",
  storeLocationsInstructions3: "3. Carregue o ficheiro usando a área acima",
  storeLocationsFetchError: "Erro ao carregar lojas",
  storeLocationsCreateSuccess: "Loja criada com sucesso",
  storeLocationsCreateError: "Erro ao criar loja",
  storeLocationsUpdateSuccess: "Loja atualizada com sucesso",
  storeLocationsUpdateError: "Erro ao atualizar loja",
  storeLocationsDeleteSuccess: "Loja eliminada com sucesso",
  storeLocationsDeleteError: "Erro ao eliminar loja",
  storeLocationsDeleteConfirm: "Tem a certeza que deseja eliminar esta loja?",
  storeLocationsToggleSuccess: "Estado da loja atualizado com sucesso",
  storeLocationsToggleError: "Erro ao atualizar estado da loja",
  storeLocationsAddStore: "Adicionar Loja",
  storeLocationsSearchPlaceholder: "Pesquisar lojas...",
  storeLocationsIncludeInactive: "Incluir inativas",
  storeLocationsTableId: "ID",
  storeLocationsTableName: "Nome",
  storeLocationsTableAddress: "Morada",
  storeLocationsTablePostalCode: "Código Postal",
  storeLocationsTableStatus: "Estado",
  storeLocationsTableActions: "Ações",
  storeLocationsActive: "Ativa",
  storeLocationsInactive: "Inativa",
  storeLocationsDeactivate: "Desativar",
  storeLocationsActivate: "Ativar",
  storeLocationsEdit: "Editar",
  storeLocationsDelete: "Eliminar",
  storeLocationsNoStores:
    "Nenhuma loja encontrada. Adicione a sua primeira loja para começar.",
  storeLocationsNoResults:
    "Nenhuma loja corresponde aos critérios de pesquisa.",
  storeLocationsCreateStore: "Criar Loja",
  storeLocationsEditStore: "Editar Loja",
  storeLocationsFormId: "ID da Loja",
  storeLocationsFormName: "Nome",
  storeLocationsFormAddress: "Morada",
  storeLocationsFormPostalCode: "Código Postal",
  storeLocationsFormLatitude: "Latitude",
  storeLocationsFormLongitude: "Longitude",
  storeLocationsFormActive: "Ativa",
  storeLocationsImportFromFile: "Importar de JSON",
  storeLocationsTabList: "Lista",
  storeLocationsTabMap: "Mapa",
  storeLocationsMapInstructions:
    "Clique num marcador no mapa ou num cartão de loja abaixo para ver detalhes.",
  storeLocationsViewDetails: "Ver Detalhes",
  storeLocationsStoreSingular: "loja",
  storeLocationsStorePlural: "lojas",
  storeLocationsShown: "mostradas",
  storeLocationsMapOverlayHint:
    "Clique nos cartões de loja abaixo para ver detalhes",
  storeLocationsViewOnMap: "Ver no Google Maps",
  storeLocationsStoreDetails: "Detalhes da Loja",
  storeLocationsCreatedAt: "Criado em",
  storeLocationsUpdatedAt: "Atualizado em",
  storeLocationsExportToJson: "Exportar para JSON",
  storeLocationsExportSuccess: "Lojas exportadas com sucesso",
  storeLocationsExportError: "Erro ao exportar lojas",
  storeLocationsExporting: "A exportar lojas...",
  storeStockCheckStock: "Consultar Stock",
  storeStockModalTitle: "Consultar Stock",
  storeStockProductIdLabel: "ID do Produto",
  storeStockProductIdPlaceholder: "Digite o ID do produto",
  storeStockProductIdRequired: "Por favor, introduza um ID de produto",
  storeStockCheckButton: "Consultar",
  storeStockChecking: "A consultar...",
  storeStockCheckError: "Erro ao consultar stock",
  storeStockResult: "Resultado",
  storeStockProductId: "Produto",
  storeStockQuantity: "Quantidade",
  storeStockStatus: "Estado",
  storeStockNoStockStatus: "Sem Stock",
  storeStockLastUnits: "Últimas unidades",
  storeStockLowStock: "Poucas unidades",
  storeStockManyUnits: "Várias unidades",
  storeStockLastUnitsWarning: "⚠️ Últimas unidades disponíveis",
  storeStockLowStockWarning: "⚠️ Poucas unidades disponíveis",
  storeStockNoStock: "Sem stock disponível",
  storeLocationsTabWarehouses: "Armazéns",
  warehousesTitle: "Armazéns e Centro Logístico",
  warehousesAddWarehouse: "Adicionar Armazém",
  warehousesEditWarehouse: "Editar Armazém",
  warehousesCenterId: "Código SAP",
  warehousesName: "Nome",
  warehousesAddress: "Morada",
  warehousesPostalCode: "Código Postal",
  warehousesActive: "Ativo",
  warehousesIncludeInactive: "Incluir inativos",
  warehousesEmpty: "Ainda não há armazéns configurados",
  warehousesFetchError: "Erro ao obter os armazéns",
  warehousesCreateSuccess: "Armazém criado",
  warehousesCreateError: "Erro ao criar o armazém",
  warehousesUpdateSuccess: "Armazém atualizado",
  warehousesUpdateError: "Erro ao atualizar o armazém",
  warehousesDeleteSuccess: "Armazém removido",
  warehousesDeleteError: "Erro ao remover o armazém",
  warehousesDeleteConfirm: "Remover este armazém?",
  warehousesCheckStock: "Verificar stock",
  warehousesStockProductId: "Código SAP do produto",
  warehousesStockResult: "Unidades em stock",
  warehousesStockError: "Erro ao verificar o stock",
  clickRunToStartManual:
    "Clique em 'Executar Ingestão' para processar produtos manualmente",
  scheduledIngestionNote:
    "Nota: As ingestões agendadas são geridas pelo scheduler acima",

  // Products Management — KPI, Histórico, Logs
  inVectorStore: "No vector store",
  schedulerLabel: "Scheduler",
  every: "A cada",
  idle: "Inativo",
  noDataYet: "Sem dados ainda",
  ingestionStarted: "Ingestão iniciada...",
  ingestionCompleted: "Ingestão concluída com sucesso",
  ingestionFailed: "Ingestão falhou",
  triggeringIngestion: "A iniciar ingestão de produtos...",
  ingestionTriggered: "Ingestão acionada, a aguardar resposta...",
  ingestionLogs: "Logs de Ingestão",
  ingestionHistory: "Histórico de Ingestão",
  ingestionHistoryDescription: "Execuções recentes de ingestão nesta sessão",
  duration: "Duração",
  details: "Detalhes",
  cacheManagement: "Gestão de Cache",
  cacheManagementDescription: "Gerir cache Redis para o seu tenant",
  connected: "Conectado",
  disconnected: "Desconectado",

  // Similarity Search
  similaritySearch: "Busca de Similaridade",
  internalProceduresDescription: "Pesquisar através de procedimentos internos e informações administrativas",
  similaritySearchDescription:
    "Pesquisar conteúdo similar usando consultas em linguagem natural",
  selectCollection: "Selecionar Coleção",
  generalInformationDescription:
    "Pesquisar através de informações gerais da empresa e políticas",
  campaignsDescription:
    "Pesquisar através de campanhas de marketing e conteúdo promocional",
  productsDescription:
    "Pesquisar através do catálogo de produtos e especificações",
  productsSearchDescription:
    "Pesquisar no catálogo de produtos usando linguagem natural",
  searchQuery: "Consulta de Pesquisa",
  enterSearchQuery: "Introduza uma consulta de pesquisa...",
  resultsLimit: "Limite de Resultados",
  rawSearch: "Busca Bruta",
  searchFilters: "Filtros de Pesquisa",
  minPrice: "Preço Mínimo (€)",
  maxPrice: "Preço Máximo (€)",
  brands: "Marcas (separadas por vírgula)",
  availability: "Disponibilidade",
  pricePreference: "Preferência de Preço",
  inStock: "Em Stock",
  outOfStock: "Sem Stock",
  cheapest: "Mais Barato",
  mostExpensive: "Mais Caro",
  any: "Qualquer",
  search: "Pesquisar",
  searching: "A pesquisar...",
  searchResults: "Resultados da Pesquisa",
  noResultsFound: "Nenhum resultado encontrado",
  noResultsDescription:
    "Tente ajustar os seus termos de pesquisa ou experimente uma coleção diferente",
  searchError: "Erro na pesquisa",
  readyToSearch: "Pronto para Pesquisar",
  readyToSearchDescription:
    "Tente pesquisar por conteúdo, descrições ou características",
  pleaseEnterQuery: "Por favor, introduza uma consulta de pesquisa",
  resultDetails: "Detalhes do Resultado",
  content: "Conteúdo",

  // Product Details Modal
  basicInformation: "Informação Básica",
  productDetails: "Detalhes do Produto",
  keyFeatures: "Características Principais",
  embeddedText: "Texto Embedado",
  metadata: "Metadados",
  similarityScore: "Pontuação de Similaridade",
  price: "Preço",
  brand: "Marca",
  model: "Modelo",
  stock: "Stock",
  sapCode: "Código SAP",
  ean: "EAN",
  productUrl: "URL do Produto",
  viewProduct: "Ver Produto",
  units: "unidades",
  embeddedTextDescription:
    "Este é o texto que foi embedado no vector store para busca por similaridade",
  noImageAvailable: "Nenhuma imagem disponível",

  // Vector Store Statistics
  vectorStoreStatistics: "Estatísticas do Vector Store",
  vectorStoreStatisticsDescription:
    "Monitorizar coleções do vector store e saúde do sistema",
  totalCollections: "Total de Coleções",
  totalVectors: "Total de Vetores",
  systemHealth: "Saúde do Sistema",
  healthy: "Saudável",
  collectionsDetails: "Detalhes das Coleções",
  vectors: "Vetores",
  vectorSize: "Dimensão dos Vetores",
  distance: "Distância",
  clear: "Limpar",
  clearAll: "Limpar Tudo",
  clearCollectionConfirmation:
    'Tem a certeza de que pretende limpar a coleção "{collectionName}"? Esta ação não pode ser desfeita.',
  clearAllCollectionsConfirmation:
    "Tem a certeza de que pretende limpar TODAS as coleções? Esta ação não pode ser desfeita.",
  failedToFetchVectorStoreStats: "Falha ao obter estatísticas do vector store",
  failedToClearCollection: "Falha ao limpar coleção: {error}",
  failedToClearAllCollections: "Falha ao limpar todas as coleções: {error}",
  collectionClearedSuccessfully: "Coleção limpa com sucesso!",
  allCollectionsClearedSuccessfully: "Todas as coleções limpas com sucesso!",
  insufficientPermissions:
    "Permissões insuficientes. Apenas administradores podem limpar coleções.",
  collectionNotFound: "Coleção não encontrada.",
  serverErrorClearCollection:
    "Erro do servidor ao limpar coleção. Tente novamente.",
  insufficientPermissionsClearAll:
    "Permissões insuficientes. Apenas administradores podem limpar todas as coleções.",
  serverErrorClearAllCollections:
    "Erro do servidor ao limpar todas as coleções. Tente novamente.",
  unauthorizedAccess: "Acesso não autorizado. Por favor, faça login novamente.",
  insufficientPermissionsStats:
    "Permissões insuficientes para visualizar estatísticas do vector store.",
  serverErrorStats: "Erro do servidor ao obter estatísticas. Tente novamente.",
  networkErrorStats: "Erro de rede. Verifique a sua ligação e tente novamente.",
  reindexationStatus: "Re-indexação",
  reindexationDescription: "Re-processar todos os ficheiros com o modelo de embedding atual",
  runReindexation: "Executar Re-indexação",
  noReindexationRunning: "Nenhuma re-indexação em execução",
  clickRunToStartReindex: "Clique no botão acima para re-processar todos os ficheiros",
  systemInformation: "Informação do Sistema",
  vectorStoreInfo:
    "As estatísticas do vector store são atualizadas em tempo real. Use o botão de atualizar para obter os dados mais recentes. Limpar coleções irá remover permanentemente todos os vetores e não pode ser desfeito.",
  refreshing: "A atualizar...",
  noCollections: "Nenhuma Coleção Encontrada",
  noCollectionsDescription: "Nenhuma coleção do vector store está disponível.",
  actionCannotBeUndone: "Esta ação não pode ser desfeita!",
  allCollections: "Todas as Coleções",
  confirm: "Confirmar",
  typeToConfirm: "Escreva para confirmar",
  typeConfirmationText: "Escreva",
  toProceed: "para prosseguir",

  // Grafana Dashboard
  grafanaDashboard: "Logs Explore",
  grafanaDescription: "Explorador de Logs do Agente IA",
  grafanaError: "Erro do Painel Grafana",
  grafanaConnectionError:
    "Falha ao carregar o painel Grafana. Verifique se o Grafana está em execução.",
  loadingDashboard: "A carregar painel...",
  openInNewTab: "Abrir em Nova Aba",
  retry: "Tentar Novamente",
  grafanaAuthRequired: "Autenticação Grafana Necessária",
  grafanaAuthMessage:
    "Para aceder ao explorador de logs do Grafana, precisa de se autenticar primeiro no Grafana. Após fazer login, volte a esta página e clique no botão 'Atualizar Após Login' para carregar o painel.",
  loginToGrafana: "Entrar no Grafana",
  refreshAfterLogin: "Atualizar Após Login",

  // Advanced Cache Management (Admin Only)
  advancedCacheManagement: "Gestão Avançada de Cache do Chat",
  adminsOnly: "Apenas Admins",
  advancedCacheManagementDescription:
    "Limpar caches técnicos do sistema - usar com precaução",
  clearTenantConfigCache: "Cache de Configuração do Tenant",
  clearTenantConfigCacheDescription: "Limpar cache de configuração do tenant",
  clearAgentCache: "Cache do Agente",
  clearAgentCacheDescription: "Limpar cache do agente e metadados do agente",
  clearChatHistoryCache: "Cache do Histórico de Chat",
  clearChatHistoryCacheDescription: "Limpar todo o histórico de chat",
  clearIngestionStatusCache: "Cache do Estado de Ingestão",
  clearIngestionStatusCacheDescription: "Limpar cache do estado de ingestão",
  clearWorkflowCache: "Cache do Workflow",
  clearWorkflowCacheDescription: "Limpar cache de configuração do workflow",
  clearAllTechnicalCache: "Limpar Todos os Caches Técnicos",
  clearAllTechnicalCacheDescription: "Limpar todos os caches técnicos",
  clearAllButton: "Limpar Tudo",

  // Tenant Management
  superAdministrator: "Super Administrador",
  tenantManagement: "Gestão de Tenants",
  tenantManagementDescription: "Gerir tenants e as suas configurações",
  managingTenant: "A gerir o tenant:",
  exitTenant: "Sair",
  enterTenant: "Entrar",
  inactiveTenantCannotEnter: "Tenant inativo, não é possível entrar",
  tenants: "Tenants",
  createFirstTenant: "Crie o seu primeiro tenant para começar",
  createTenant: "Criar Tenant",
  addNewTenant: "Adicionar Novo Tenant",
  tenantName: "Nome do Tenant",
  chatwootApiUrl: "Chatwoot API URL",
  chatwootAccountId: "Chatwoot Account ID",
  chatwootInboxId: "Chatwoot Inbox ID",
  chatwootApiToken: "Chatwoot API Token",
  chatwootAgentApiToken: "Chatwoot Agent API Token",
  chatwootWebhookToken: "Chatwoot Webhook Token",
  chatwootHmacToken: "Chatwoot HMAC Token",
  chatwootHmacTokenDescription:
    "Usado para validação de identidade no widget Chatwoot",
  externalAccessApiKey: "External Access API Key",
  externalAccessApiKeyDescription: "Chave API para acesso externo",
  accountId: "Account ID",
  active: "Ativo",
  inactive: "Inativo",
  updatedAt: "Atualizado em",
  actions: "Ações",
  viewDetails: "Ver Detalhes",
  deactivate: "Desativar",
  editTenant: "Editar Tenant",
  editTenantDescription: "Deixe os campos vazios para manter os valores atuais",
  leaveEmptyToKeepCurrent: "Deixe vazio para manter o valor atual",
  tenantDetails: "Detalhes do Tenant",
  tenantId: "Tenant ID",
  create: "Criar",
  creating: "A criar...",
  allFieldsRequired: "Todos os campos são obrigatórios",
  tenantCreatedSuccessfully: "Tenant criado com sucesso",
  tenantUpdatedSuccessfully: "Tenant atualizado com sucesso",
  tenantDeactivatedSuccessfully: "Tenant desativado com sucesso",
  failedToFetchTenants: "Falha ao obter tenants",
  failedToCreateTenant: "Falha ao criar tenant",
  failedToUpdateTenant: "Falha ao atualizar tenant",
  failedToDeactivateTenant: "Falha ao desativar tenant",
  failedToFetchTenantDetails: "Falha ao obter detalhes do tenant",
  confirmDeactivateTenant:
    'Tem a certeza de que pretende desativar o tenant "{name}"?',
  showToken: "Mostrar",
  hideToken: "Ocultar",
  deactivateTenant: "Desativar Tenant",
  tenantInformation: "Informação do Tenant",
  deactivateTenantWarning:
    "Esta ação irá desativar o tenant. O tenant deixará de ter acesso ao sistema, mas os dados serão preservados.",
  activate: "Ativar",
  tenantActivatedSuccessfully: "Tenant ativado com sucesso",
  failedToActivateTenant: "Falha ao ativar tenant",
  tokenCopied: "Token copiado",
  tokenCopyFailed: "Não foi possível copiar o token",
  widgetTokenRotated: "Token do widget rodado",
  widgetTokenRotateFailed: "Não foi possível rodar o token do widget",
  rotateWidgetToken: "Rodar Token do Widget",
  rotateWidgetTokenWarning: "O token anterior deixará de funcionar imediatamente.",
  rotate: "Rodar",
  rotating: "A rodar...",

  // Account Management
  accountManagement: "Gestão de Contas",
  accounts: "Contas",

  // Chat Management
  chatManagement: "Gestão de Chats",
  chats: "Chats",
  chatwootChannelOptional: "Canal Chatwoot (opcional)",
  identityCookieIntegration: "Integração do Cookie de Identidade",
  identityCookieIntegrationDescription:
    "Espelha um cookie próprio (first-party) deste chat num atributo de contacto, para o agente reconhecer visitantes recorrentes.",
  identityCookieEnabled: "Integração do cookie de identidade ativada",
  cookieName: "Nome do Cookie",
  attributeKey: "Chave do Atributo",
  cdpEnrichmentTitle: "Opcional: Enriquecimento CDP (Bloomreach)",
  cdpEnrichmentDescription:
    "Envia também a identidade para uma Customer Data Platform (atualmente o Bloomreach Engagement) para personalização entre canais.",
  cdpEnrichmentEnabled: "Enriquecimento CDP ativo",
  apiBaseUrl: "URL Base da API",
  projectToken: "Token do Projeto",
  apiKeyId: "ID da Chave de API",
  apiSecret: "Segredo da API",
  bloomreachAttributes: "Atributos (JSON)",
  bloomreachAttributesHelp:
    "Array de definições de atributos enviadas ao Bloomreach, em JSON.",
  loadingIdentityCookieIntegration: "A carregar a integração do cookie de identidade...",
  failedToFetchIdentityCookieIntegration: "Falha ao obter a integração do cookie de identidade",
  chatwootChannelOptionalHelp:
    "Deixa em branco para um chat só de voz ou só widget.",
  chatwootWebhookBaseUrl: "URL base dos webhooks do Chatwoot",
  chatwootWebhookBaseUrlHelp:
    "A origem por onde o Chatwoot desta conta chega ao backend, sem caminho. A configuração das transferências de cada chat monta a partir dela o webhook da inbox de transferências. Mudá-la depois não atualiza as inboxes já criadas, e os chats delas passam a dizer que a inbox já não bate certo.",
  handoffSetupTitle: "Transferências para operador",
  handoffSetupDescription:
    "Cria no Chatwoot a inbox de transferências deste chat e grava-a no chat. O Configurar pede confirmação e depois atua logo, sem esperar pelo Save.",
  handoffSetupLoading: "A ler a configuração das transferências...",
  handoffSetupLoadFailed: "Não foi possível ler a configuração das transferências: {detail}. Para tentar outra vez, fechar e voltar a abrir o diálogo.",
  handoffSetupFailed: "Falha ao configurar as transferências",
  handoffSetupState_not_configured: "Por configurar, e pronto a configurar.",
  handoffSetupState_blocked: "Não se pode configurar até se resolver o que está na lista.",
  handoffSetupState_configured: "Configurado.",
  handoffSetupState_mismatch: "Configurado, mas a inbox no Chatwoot já não bate certo com o que o chat grava.",
  handoffSetupState_inbox_missing: "Configurado, mas a inbox que o chat grava já não existe no Chatwoot.",
  handoffSetupState_chatwoot_error: "Não foi possível ler o Chatwoot.",
  handoffSetupChatwootVersion: "Chatwoot {version}",
  handoffSetupInbox: "Inbox {id}: {name}",
  handoffSetupButton: "Configurar",
  handoffSetupRunning: "A configurar...",
  handoffSetupConfirmTitle: "Configurar as transferências de {name}?",
  handoffSetupConfirmWhat:
    "Isto cria no Chatwoot da conta a inbox de transferências deste chat, copia para ela os membros da inbox atual do chat, e grava-a no chat. Desfazer obriga a apagar a inbox no Chatwoot e a limpar três colunas com SQL.",
  handoffSetupConfirmOrder:
    "Só avançar se a versão do widget que mostra o operador (W1) já estiver publicada no widget deste ambiente: um widget antigo mostra as mensagens do operador como sendo do bot.",
  handoffSetupConfirmButton: "Criar a inbox",

  // Chat selection for file upload
  selectChatsAccess: "Chats com Acesso",
  noChatSelectedInfo: "Se não selecionar nenhum chat, o ficheiro NÃO ficará disponível em nenhum chat.",
  
  // Chat selection in configurations
  selectChat: "Selecionar Chat",
  configsForThisChat: "A visualizar configurações específicas deste chat",
  chatConfigInfo: "Configurações específicas deste chat",
  loadingChatConfigs: "A carregar configurações do chat...",
  clearCacheForChat: "Limpar cache para este chat",
  clearingCacheFor: "A limpar cache para",
  breakdownByChat: "Por Chat",
  
  // Chat management modal
  manageChatsForFile: "Gerir Chats do Ficheiro",
  collection: "Coleção",
  selectChats: "Selecionar Chats (selecione um ou mais)",
  noChatsAvailable: "Nenhum chat disponível",
  noChatsAvailableMessage: "Por favor, certifique-se de que os chats estão configurados para este tenant.",
  chatsSelected: "{count} chat(s) selecionado(s)",
  updateChats: "Atualizar Chats",
  updating: "A atualizar...",
  chatsUpdatedSuccessfully: "Chats atualizados com sucesso",
  failedToUpdateChats: "Falha ao atualizar chats",
  noChatsAssigned: "Nenhum chat atribuído",
  atLeastOneChatRequired: "É obrigatório selecionar pelo menos um chat.",
  selectAtLeastOneChat: "Por favor, selecione pelo menos um chat antes de continuar.",
  manageChats: "Gerir Chats",

  // Folders
  newFolder: "Nova Pasta",
  folderName: "Nome da pasta",
  createFolder: "Criar Pasta",
  rename: "Renomear",
  moveTo: "Mover para...",
  moveToFolder: "Mover para pasta",
  moveHere: "Mover Para Aqui",
  moveItemDescription: "Selecione um destino para \"{name}\"",
  movedSuccessfully: "Movido com sucesso",
  searchFolders: "Pesquisar pastas...",
  searchFiles: "Pesquisar ficheiros",
  collectionRoot: "Raiz da Coleção",
  noFoldersFound: "Nenhuma pasta encontrada",
  deleteFolder: "Eliminar Pasta",
  deleteFolderConfirmation: "Isto irá eliminar permanentemente \"{name}\" e todo o seu conteúdo ({folders} subpasta(s) e {files} ficheiro(s)). Esta ação não pode ser revertida.",
  failedToCreateFolder: "Falha ao criar pasta",
  failedToRenameFolder: "Falha ao renomear pasta",
  failedToDeleteFolder: "Falha ao eliminar pasta",
  failedToMove: "Falha ao mover item",
  movedFileSuccessfully: "Ficheiro movido com sucesso",
  movedFilesSuccessfully: "{count} ficheiros movidos com sucesso",
  movedFilesPartial: "{moved} de {total} ficheiros movidos ({failed} sem sucesso)",
  movedNoFiles: "Nenhum ficheiro foi movido",
  movedFolderSuccessfully: "Pasta movida com sucesso",
  movedFoldersSuccessfully: "{count} pastas movidas com sucesso",
  movedFoldersPartial: "{moved} de {total} pastas movidas ({failed} sem sucesso)",
  movedNoFolders: "Nenhuma pasta foi movida",
  deletedFolderSuccessfully: "Pasta eliminada com sucesso",
  deletedFileSuccessfully: "Ficheiro eliminado com sucesso",
  deletedFilesSuccessfully: "Todos os {count} ficheiros eliminados com sucesso",
  deletedFilesPartial: "{successful} de {total} ficheiros eliminados, {failed} falharam",
  folderSingular: "pasta",
  folderPlural: "pastas",
  fileSingular: "ficheiro",
  filePlural: "ficheiros",
  rootFolder: "Raiz",
  move: "Mover",
  dropHereToMove: "Largar aqui para mover",
  fileAlreadyExistsInAnotherFolder: "Já existe um ficheiro com este nome noutra pasta. Renomeie o ficheiro ou elimine o existente primeiro.",

  // Folder upload
  uploadFolder: "Carregar Pasta",
  uploadFolderSummary: "{files} ficheiros ({pdf} PDF, {txt} TXT, {md} MD) em {folders} subpasta(s)",
  invalidFilesInFolder: "Alguns ficheiros nesta pasta não são suportados:",
  emptyFolder: "A pasta está vazia ou não contém ficheiros suportados",
  mixedDropError: "Por favor, largue ficheiros ou uma pasta, não ambos",
  creatingFolders: "A criar pastas...",

  // Widget settings page
  widget: "Widget",
  widgetSettings: "Definições do Widget",
  widgetSettingsDescription: "Personalize a aparência e comportamento do widget de chat.",
  theme: "Tema",
  colors: "Cores",
  primaryColor: "Primária",
  secondaryColor: "Secundária",
  launcher: "Lançador",
  launcherBackground: "Fundo do launcher",
  launcherText: "Texto do launcher",
  launcherIcon: "URL do ícone",
  launcherShape: "Forma",
  launcherShapePill: "Cápsula",
  launcherShapeCircle: "Círculo",
  launcherSize: "Tamanho",
  launcherCorner: "Canto",
  launcherCornerBottomRight: "Inferior direito",
  launcherCornerBottomLeft: "Inferior esquerdo",
  launcherOffsetX: "Deslocamento X",
  launcherOffsetY: "Deslocamento Y",
  launcherAnimation: "Animação",
  launcherAnimationNone: "Nenhuma",
  launcherAnimationFloat: "Flutuar",
  launcherAnimationPulse: "Pulsar",
  launcherAnimationBounce: "Saltar",
  logo: "Logótipo",
  logoUrl: "URL do logótipo",
  customCSS: "CSS personalizado",
  customCSSPanel: "CSS personalizado — Painel",
  customCSSLauncher: "CSS personalizado — Lançador",
  customCSSPanelPlaceholder: ".kodly-ai-agent-panel {\n  padding: 12px;\n}",
  customCSSLauncherPlaceholder: ".kodly-ai-agent-launcher:hover {\n  transform: scale(1.1);\n}",
  // Modal informativo do CSS do lançador / painel
  infoLauncherTitle: "Personalização do lançador",
  infoPanelTitle: "Personalização do painel",
  infoStableClasses: "Classes estáveis",
  infoDataAttributes: "Atributos de dados",
  infoCssVars: "Propriedades CSS personalizadas",
  infoKeyframes: "Keyframes de animação (redefiníveis)",
  infoCssExamples: "Exemplos",
  infoCopy: "Copiar",
  infoCopied: "Copiado!",
  infoClose: "Fechar",
  infoHelpLabelLauncher: "Ajuda: personalização do lançador",
  infoHelpLabelPanel: "Ajuda: personalização do painel",
  infoLauncherScopingNote:
    "Os seletores de topo têm de começar por .kodly-ai-agent-launcher. At-rules permitidas: @keyframes, @media, @supports. Tudo o resto é bloqueado.",
  infoPanelHintsNote:
    "Estes hooks são estáveis hoje, mas podem mudar com atualizações do widget. Para estabilidade a longo prazo, prefere os campos estruturados do tema acima (cores primária/secundária, logótipo, textos).",
  infoExampleFloatGlow: "Animação flutuante + brilho",
  infoExampleGlass: "Glassmorphism",
  infoExampleHoverScale: "Escala em hover + sombra elevada",
  infoExampleHeaderGradient: "Fundo personalizado do cabeçalho",
  infoExampleBubbleShape: "Forma das bolhas de mensagem",
  infoExampleCustomFont: "Fonte personalizada para mensagens",
  copy: "Conteúdo",
  headerTitle: "Título do cabeçalho",
  headerTitlePlaceholder: "ex: Assistente virtual",
  launcherTitle: "Título do lançador",
  launcherTitlePlaceholder: "ex: Precisas de ajuda?",
  botName: "Nome do bot",
  botNamePlaceholder: "ex: Kodly",
  botAvatarUrl: "URL do avatar do bot",
  welcomeTitle: "Título de boas-vindas",
  welcomeDescription: "Descrição de boas-vindas",
  defaultQuickReplies: "Respostas rápidas por omissão",
  pageContexts: "Respostas rápidas por página",
  pageContextsHint:
    "Ganha o primeiro contexto da lista cujos padrões correspondem à página. Ao guardar " +
    "e ao importar, a plataforma arruma a lista para o mais específico ficar acima do " +
    "mais abrangente, por exemplo /produto/lego* acima de /produto/*. Nos outros casos " +
    "em que dois contextos correspondem à mesma página, como /produto/*oled* e " +
    "/produto/tv-*, ganha o que estiver mais acima na lista. Para trocar dois destes, " +
    "exporta, muda a ordem no ficheiro e volta a importar. " +
    "Páginas sem contexto correspondente recebem as respostas por omissão acima, no " +
    "idioma que a página pediu. As respostas de um contexto não variam por idioma: " +
    "saem tal e qual como estão escritas, para todos os mercados que este widget " +
    "serve. A pré-visualização ao lado mostra sempre as respostas por omissão, porque não tem " +
    "página de destino; para ver um contexto, abre o widget no site.",
  pageContext: "Contexto",
  pageContextName: "Nome",
  pageContextNamePlaceholder: "ex: Produto",
  pageContextPatterns: "Padrões de URL",
  pageContextPatternsPlaceholder: "/produto/**\n/en/product/**",
  pageContextPatternsHint:
    "Um padrão por linha, cada um a começar por /. Colar o URL completo também " +
    "funciona: o domínio e a query string são ignorados. * corresponde dentro de um " +
    "segmento, ** atravessa /. A barra final é ignorada e maiúsculas/minúsculas são " +
    "equivalentes. Atenção: /produto/** exige um segmento a seguir, ou seja não " +
    "corresponde a /produto sozinho.",
  pageContextReplies: "Respostas rápidas",

  // Import e export dos contextos de página (RPAA-246). Os índices chegam do
  // backend a contar de 0 e são mostrados a contar de 1, a nomear a entrada do
  // FICHEIRO: um import recusado não escreve nada, portanto a lista que está no
  // ecrã continua a ser a antiga.
  pageContextsExport: "Exportar",
  pageContextsExportHint: "Exporta o que está gravado, não as alterações por gravar.",
  pageContextsExportFailed: "Não foi possível exportar os contextos de página.",
  pageContextsImport: "Importar",
  pageContextsImportHint: "Substitui todos os contextos de página deste chat.",
  pageContextsImportBlocked:
    "Tens alterações por gravar. Grava ou descarta antes de importar.",
  pageContextsImportTitle: "Importar contextos de página",
  pageContextsDragDrop: "Arrasta um ficheiro JSON para aqui, ou clica para escolher.",
  pageContextsCountPlain: "{count} contextos de página",
  pageContextsCountAtCap: "{count} contextos de página: o máximo que este chat permite.",
  pageContextsImportConfirm:
    "Este chat tem {current} contextos de página. O ficheiro traz {incoming}, e importar " +
    "substitui todos os que lá estão.",
  pageContextsImportConfirmWithReplies:
    "Este chat tem {current} contextos de página. O ficheiro traz {incoming}, e importar " +
    "substitui todos os que lá estão. Substitui também as Respostas rápidas por omissão.",
  pageContextsImportReplace: "Substituir",
  pageContextsImporting: "A importar...",
  pageContextsImported: "{count} contextos de página importados.",
  pageContextsFileMustBeJson: "O ficheiro tem de ser .json.",
  pageContextsFileTooLarge: "O ficheiro é demasiado grande.",
  pageContextsFileUnreadable: "Este ficheiro não é um export de contextos de página.",
  pageContextsImportRefused: "O ficheiro foi recusado",
  pageContextsFileEntry: "entrada {index} do ficheiro",
  pageContextsImportFailed: "Não foi possível importar o ficheiro.",
  pageContextsWarningsTitle: "Confirma isto antes de contares com o resultado",
  pageContextsWarningInert:
    "Estes contextos nunca aparecem, porque não têm padrões de URL ou não têm respostas " +
    "rápidas: {contexts}.",
  pageContextsWarningInertOne:
    "Este contexto nunca aparece, porque não tem padrões de URL ou não tem respostas " +
    "rápidas: {contexts}.",
  pageContextsWarningCatchAll:
    "Há {shadowed} contextos que nunca aparecem, porque {context} apanha todas as páginas " +
    "e está acima deles.",
  pageContextsWarningCatchAllOne:
    "Há um contexto que nunca aparece, porque {context} apanha todas as páginas e está " +
    "acima dele.",
  pageContextsWarningDuplicate:
    "O padrão {pattern} está em {contexts}. Nessas páginas só aparece o que estiver mais " +
    "acima na lista.",
  pageContextsWarningChatMismatch:
    "O ficheiro foi exportado de outro chat. Os contextos foram importados na mesma.",
  pageContextsWarningReordered:
    "{count} contextos subiram na lista, para ficarem acima de outro que lhes tirava " +
    "páginas: {contexts}.",
  pageContextsWarningReorderedOne:
    "Um contexto subiu na lista, para ficar acima de outro que lhe tirava páginas: " +
    "{contexts}.",
  pageContextsNamed: "«{name}»",
  pageContextsNamedWithEntry: "«{name}» (entrada {index})",
  pageContextsFileEntryLabel: "a entrada {index} do ficheiro",
  pageContextsListAnd: " e ",
  pageContextsListAndMore: "{list} e mais {count}",

  addPageContext: "Adicionar contexto",
  previous: "Anterior",
  next: "Seguinte",
  pageContextsSearch: "Pesquisar por nome ou padrão",
  pageContextsCount: "contextos",
  pageContextsLoadError: "Não foi possível carregar os contextos.",
  pageContextsNoMatch: "Nenhum contexto corresponde à pesquisa.",
  pageContextsSaveHint:
    "Cada contexto guarda-se sozinho: o botão Guardar abaixo não os transporta.",
  savePageContext: "Guardar este contexto",
  pageContextAddFailed: "Não foi possível adicionar o contexto.",
  pageContextSaveFailed: "Não foi possível guardar o contexto.",
  pageContextsOthersReordered:
    "Outros contextos mudaram de ordem para nenhum ficar abaixo de outro que o cobre: " +
    "{count}.",
  pageContextMovedUpOnSave:
    "O contexto subiu na lista: o mais específico fica acima do mais abrangente.",
  pageContextMovedDownOnSave:
    "O contexto desceu na lista: o mais específico fica acima do mais abrangente.",
  pageContextDeleteFailed: "Não foi possível apagar o contexto.",
  pageContextsUnsavedCount: "{count} contexto{plural} com alterações por guardar.",
  pageContextsLeaveConfirm:
    "Há contextos de página com alterações por guardar. Se mudar de chat, essas alterações perdem-se. Continuar?",
  pageContextDeleteConfirm:
    'Tem a certeza de que pretende apagar o contexto "{name}"? Os padrões e as respostas rápidas dele são apagados de imediato. Esta ação não pode ser desfeita.',
  removePageContext: "Remover contexto",
  patternSingular: "padrão",
  patternPlural: "padrões",
  replySingular: "resposta",
  replyPlural: "respostas",
  addQuickReply: "Adicionar resposta rápida",
  moveUp: "Mover para cima",
  moveDown: "Mover para baixo",
  tooManyQuickReplies: "Máximo de 6 respostas rápidas.",
  quickReplyPlaceholder: "Texto da resposta rápida",
  features: "Funcionalidades",
  fileUpload: "Carregamento de ficheiros",
  fileUploadDescription: "Permite anexar ficheiros nas conversas com agentes humanos.",
  audioMessages: "Mensagens de áudio",
  audioMessagesDescription: "Permite gravar e enviar notas de voz.",
  productCardDelivery: "Prazo de entrega nos cartões de produto",
  productCardDeliveryDescription:
    "Mostra a estimativa de entrega em cada cartão de produto, ou o estado de disponibilidade quando o produto ainda não pode ser enviado.",
  productCardTagBadges: "Etiqueta nos cartões de produto",
  productCardTagBadgesDescription:
    'Mostra uma etiqueta de campanha ou de estado do produto ("Pré-Venda", "Artigo de Exposição") no topo do cartão.',
  productCardDiscountBadge: "Percentagem de desconto nos cartões de produto",
  productCardDiscountBadgeDescription: "Mostra a percentagem de desconto sobre a foto do produto.",
  productCardHoverImage: "Segunda foto ao passar o rato",
  productCardHoverImageDescription:
    "Mostra a segunda foto do produto quando o rato fica sobre o cartão (só em computador).",
  productCardViewCta: 'Botão "ver produto" nos cartões',
  productCardViewCtaDescription:
    "Acrescenta um botão de largura total ao fundo do cartão, que abre a página do produto. Fica escondido quando o botão de carrinho está ligado.",
  cardLinksSameTab: "Abrir recomendações na mesma página",
  cardLinksSameTabDescription:
    "Os cartões de produto e curados navegam na página atual em vez de abrir um novo separador, e o chat reabre por cima. Aplica-se apenas a links do próprio site (no telemóvel, o chat reabre com um toque no botão).",
  previewPanel: "Painel",
  previewLauncher: "Lançador",
  previewWelcome: "Boas-vindas",
  previewDesktop: "Desktop",
  previewMobile: "Telemóvel",
  previewInviteShow: "Mostrar convite",
  previewInvitePlaceholder: "Mensagem do convite",
  previewInviteSample: "Precisas de ajuda a escolher?",
  previewInviteHint: "Só para pré-visualizar. O texto do convite vem do vosso site, não destas definições.",
  reloadPreview: "Recarregar pré-visualização",
  previewUnavailable: "Pré-visualização indisponível",
  previewLanguage: "Pré-visualização em {language}.",
  previewLanguageOtherTab:
    "Pré-visualização em {language}. O separador {tab} ainda não tem pré-visualização própria.",
  welcomeTitlePlaceholder: "ex: Olá! 👋",
  welcomeDescriptionPlaceholder: "ex: Em que podemos ajudar?",
  priceInfoNotice: "Aviso legal de preços",
  priceInfoNoticePlaceholder: "ex: Os preços apresentados são válidos apenas na loja online...",
  priceInfoNoticeHint:
    "Mostrado num popover atrás do ícone (i) junto ao preço nos cartões de produto. Deixar vazio esconde o ícone.",
  resetToDefaults: "Repor predefinições",
  resetToDefaultsTooltip: "Repor todas as definições do widget para os valores predefinidos",
  resetField: "Repor predefinição",
  modifiedNotSaved: "Modificado — por gravar",
  confirmResetDefaults: "Repor todas as definições do widget para os valores predefinidos?",
  confirmResetDefaultsClearsTranslations:
    "O conteúdo é limpo em todos os idiomas, traduções incluídas.",
  confirmResetDefaultsKeepsPageContexts: "Os contextos de página ficam como estão.",
  widgetSettingsSaved: "Definições do widget guardadas",
  widgetSettingsSaveFailed: "Falha ao guardar as definições do widget",
  widgetSettingsReloadFailed:
    "Importado, mas a página não conseguiu recarregar. Atualiza para veres os contextos novos.",
  widgetLanguage: "Idioma da interface do widget",
  widgetLanguageDescription:
    "Idioma dos textos da interface do widget — não é o idioma em que o assistente responde.",
  widgetLocales: "Idiomas do widget",
  widgetLocalesDescription:
    "Os idiomas que este widget serve. O script de incorporação escolhe um com &language=. Cada um tem o seu separador em Conteúdo.",
  removeWidgetLocale: "Remover idioma",
  addWidgetLocale: "Adicionar idioma",
  copyLanguageTab: "Idioma",
  manager: "Gestor",
  assignRole: "Atribuir role",
  assignRoleDescription:
    "Apenas utilizadores com esta role do Zitadel (ou administradores) podem ver e gerir esta pasta e o seu conteúdo. Deixe vazio para a manter aberta a todos com acesso a Procedimentos Internos.",
  requiredRolePlaceholder: "ex.: logistica",
  roleAssigned: "Role da pasta atualizada",
  failedToAssignRole: "Falha ao atualizar a role da pasta",
  configurations: "Configurações",
  personalLandingDescription: "Acesso rápido às áreas que gere",
  noAccessibleSections:
    "Ainda não tem acesso a nenhuma área de gestão. Contacte o seu administrador.",

  // VTEX promotion sync (RPAA-229)
  vtexSyncTitle: "Sincronização de promoções VTEX",
  vtexSyncNow: "Sincronizar agora",
  vtexSyncStarted: "Sincronização iniciada.",
  vtexSyncing: "A sincronizar...",
  vtexSyncFinished: "Sincronização concluída. {count} por aprovar.",
  vtexSyncFinishedNothing: "Sincronização concluída. Nada por aprovar.",
  vtexSyncFinishedWithoutReport: "A sincronização terminou sem resultado. Tente outra vez.",
  vtexSyncStillRunning: "A sincronização ainda está a decorrer. Volte daqui a pouco.",
  vtexSyncFailed: "Não foi possível iniciar a sincronização",
  campaignRejectedForStore: "Campanha rejeitada para esta loja. O ficheiro fica porque outra loja a publica.",
  campaignsRejectedForStore: "{count} campanhas rejeitadas para esta loja. Os ficheiros ficam porque outras lojas as publicam.",
  campaignRejectedAndRemoved: "Campanha rejeitada e ficheiro apagado. Não volta na próxima sincronização.",
  campaignsRejectedAndRemoved: "{count} campanhas rejeitadas e ficheiros apagados. Não voltam na próxima sincronização.",
  vtexSyncDisabled: "A sincronização automática está desligada.",
  vtexViewLoadFailed: "Não foi possível ler a vista de sincronização. O que está aqui pode estar desatualizado.",
  vtexViewLoadRetry: "Tentar outra vez",
  vtexChatIsNotAStore: "Este chat não é uma loja VTEX. Escolha outra loja acima.",
  vtexChatIsNotAStoreAlone: "Este chat deixou de ser uma loja VTEX.",
  vtexNeverSynced: "ainda não sincronizou",
  vtexSalesChannel: "Canal de venda",
  vtexCondition_utm: "Precisa de código",
  vtexCondition_audience: "Só para uma campanha",
  vtexCondition_cluster: "Só para um segmento",
  vtexCondition_partial_shipping: "Portes talvez parciais",
  vtexSelectAll: "Selecionar todas",
  vtexSelectedCount: "{count} selecionadas",
  vtexSelectedCountOne: "1 selecionada",
  vtexSelectUnconditional: "Selecionar as {count} sem condição",
  vtexSelectUnconditionalOne: "Selecionar a que não tem condição",
  vtexConfirm: "Confirmar",
  vtexConfirmApprove: "Aprovar {count}?",
  vtexConfirmApproveConditional: "Aprovar {count}, das quais {conditional} têm condição?",
  vtexConfirmReject: "Rejeitar {count}?",
  vtexBulkApproved: "{count} campanhas aprovadas.",
  vtexBulkRejected: "{count} campanhas rejeitadas. Pode desfazer a rejeição nas rejeitadas.",
  vtexBulkRejectionsUndone: "{count} rejeições desfeitas. As promoções voltam à fila de aprovação na próxima sincronização.",
  vtexBulkFailed: "{count} não foram feitas. A lista mostra o que ficou por decidir.",
  vtexQueuedBadge: "{count} por aprovar",
  vtexQueuedTitle: "À espera de aprovação",
  vtexQueuedEmpty: "Nada à espera de aprovação.",
  vtexQueueUnknown: "Sem sincronização recente — a fila será conhecida depois da próxima sincronização.",
  vtexApprove: "Aprovar",
  vtexReject: "Rejeitar",
  vtexStorePicker: "Loja",
  vtexUndoRejection: "Desfazer rejeição",
  vtexUndoAllRejections: "Desfazer as {count} rejeições",
  vtexPromotionApproved: "Promoção aprovada. O agente já a lê.",
  vtexPromotionApproveFailed: "Não foi possível aprovar a promoção",
  vtexPromotionRejected: "Promoção rejeitada. Não volta nas próximas sincronizações.",
  vtexPromotionRejectFailed: "Não foi possível rejeitar a promoção",
  vtexRejectionUndone: "Rejeição desfeita. A promoção volta à fila de aprovação na próxima sincronização.",
  vtexPromotionNotRejected: "Essa promoção não estava rejeitada",
  vtexUndoRejectionFailed: "Não foi possível desfazer a rejeição",
  vtexExcludedTitle: "Fora da lista",
  vtexExcludedDescription: "Promoções que a VTEX tinha nesta sincronização e que ficaram de fora. O motivo está ao lado de cada uma.",
  vtexRejectedTitle: "Rejeitadas",
  vtexRejectedDescription: "Apagadas por alguém. Não voltam, a menos que a VTEX as altere.",
  vtexResurrectedTitle: "Voltaram depois de rejeitadas",
  vtexResurrectedDescription: "Nesta sincronização voltaram: a VTEX alterou-as depois de terem sido rejeitadas.",
  vtexOverwrittenTitle: "Texto substituído",
  vtexOverwrittenDescription: "Nesta sincronização foi reescrito texto que alguém tinha editado à mão.",
  // O backend deixou de mandar esta razão, mas o relatório em Redis não expira: um
  // escrito antes desta alteração ainda a traz, e sem a etiqueta a linha mostrava
  // "wrong_channel" em cru até à sincronização seguinte. Pode sair quando já não
  // houver relatórios antigos em lado nenhum.
  vtexReason_wrong_channel: "Outro canal de venda",
  vtexReason_no_effect: "Efeito que não sabemos ler",
  vtexReason_no_offer_text: "Sem descrição que explique a oferta",
  vtexReason_detail_404: "A VTEX já não devolve esta promoção",
  vtexReason_malformed: "Promoção mal formada na VTEX",
  vtexCurrentApproved: "aprovadas",
  vtexCurrentQueued: "por aprovar",
  vtexLastRun: "Última sincronização",

  // Analytics (RPAA-286)
  analyticsShowTable: "Ver tabela",
  analyticsShowChart: "Ver gráfico",
  analyticsDownloadTable: "Descarregar esta tabela",
  analyticsNoData: "Sem dados neste período.",
  analytics: "Analytics",
  analyticsLoadFailed: "Não foi possível carregar a analytics.",
  analyticsExport: "Exportar",
  "analyticsExportOption.conversations": "Conversas",
  "analyticsExportOption.daily": "Dados de analytics",
  "analyticsExportOption.firstQuestions": "Conteúdo e assistente",
  "analyticsExportFailed.conversations": "Não foi possível exportar as conversas.",
  "analyticsExportFailed.daily": "Não foi possível exportar os dados de analytics.",
  "analyticsExportFailed.firstQuestions": "Não foi possível exportar o conteúdo e o assistente.",
  analyticsKodlyDirectOnly: "A analytics só cobre chats servidos diretamente pela Kodly. Este chat ainda não é servido assim, por isso não há nada para mostrar.",
  analyticsNotAvailable: "n/d",
  analyticsCategory: "Categoria",
  analyticsGroup: "Grupo",
  analyticsCount: "Contagem",
  analyticsUnattributed: "Sem informação",
  analyticsNoComparison: "sem comparação",
  analyticsAbout: "Sobre {title}",
  analyticsPeriod: "Período",
  analyticsLastDays: "Últimos {count} dias",
  analyticsCustomPeriod: "Escolher datas",
  analyticsPeriodRange: "{from} a {to}",
  analyticsChooseDay: "Escolher",
  analyticsDayUnavailable: "Indisponível",
  analyticsPreviousMonth: "Mês anterior",
  analyticsNextMonth: "Mês seguinte",
  analyticsTimeZoneNote: "Dias e horas no fuso {tz}.",
  analyticsPresetEndsYesterday: "Os períodos de 7, 30 e 90 dias acabam ontem, o último dia completo.",
  analyticsHeadline: "Números principais",
  analyticsNeedsAttention: "Pede atenção",
  analyticsPageViews: "Visualizações de página",
  analyticsConversations: "Conversas",
  analyticsCustomerMessages: "Mensagens de clientes",
  analyticsStartedWithSuggestion: "Conversas iniciadas a partir de uma sugestão",
  analyticsWithoutOperator: "Conversas sem operador",
  analyticsFunnel: "Funil",
  "analyticsFunnel.page_views": "Visualizações",
  "analyticsFunnel.opens": "Aberturas",
  "analyticsFunnel.conversations": "Conversas",
  "analyticsFunnel.two_or_more": "Com 2 ou mais mensagens",
  analyticsFunnelDockedNote: "Num chat embutido na página o assistente está sempre aberto, por isso o funil começa nas conversas.",
  analyticsOpensBySource: "Aberturas por origem",
  analyticsMessagesBySource: "Mensagens de clientes por origem",
  analyticsInvites: "Convites",
  analyticsInvitesShown: "Convites mostrados",
  analyticsInvitesOpens: "Aberturas por convite",
  analyticsInvitesRate: "Taxa de abertura dos convites",
  "analytics.source.typed": "Escrita",
  "analytics.source.quick_reply": "Sugestão",
  "analytics.source.choice": "Opção do assistente",
  "analytics.source.invite": "Convite",
  "analytics.source.invite_auto": "Convite, enviado ao clicar",
  "analytics.source.host": "Pela página",
  "analytics.source.launcher": "Botão do assistente",
  "analytics.source.restore": "Reaberto na página seguinte",
  "analytics.source.docked": "Embutido na página",
  "analytics.source.voice": "Mensagem de voz",
  analyticsCompositionNote: "Sugestões, opções do assistente, convites e mensagens enviadas pela página são texto que o cliente não escreveu. Uma mensagem de voz conta como escrita: são palavras do cliente.",
  "analytics.composition.only_typed": "Só escritas ou faladas",
  "analytics.composition.mixed": "Mistas",
  "analytics.composition.only_suggestions": "Só sugestões",
  analyticsWithoutOperatorNote: "Sem operador conta-se sobre conversas, e não sobre pedidos: uma conversa pode pedir operador duas vezes.",
  "analytics.via.inactivity": "Fechadas sozinhas, por inatividade",
  "analytics.via.customer_header": "O cliente fechou no cabeçalho",
  "analytics.via.customer_agent_button": "O cliente terminou no botão",
  "analytics.via.operator": "Fechadas por um operador",
  "analytics.via.contact_merged": "Contacto juntado a outro",
  "analytics.via.open": "Ainda aberta",
  "analytics.via.unknown": "Desconhecido",
  "analytics.profile.known": "Cliente reconhecido",
  "analytics.profile.empty": "Sem perfil guardado",
  "analytics.profile.no_cookie": "Sem cookie",
  "analytics.profile.failed": "A leitura do perfil falhou",
  "analytics.profile.unreadable": "Cookie de perfil ilegível",
  "analytics.size_search.used": "Com o perfil guardado",
  "analytics.size_search.stated": "Com o que o cliente disse",
  "analytics.size_search.missing": "Sem perfil, pediu os tamanhos",
  "analytics.size_search.no_gender": "Perfil sem um só género, perguntou para quem é",
  "analytics.size_search.section": "Sem tamanho para a secção da página, pediu-o",
  "analytics.outcome.success": "Atendidos por um operador",
  "analytics.outcome.no_agent_available": "Nenhum operador disponível",
  "analytics.outcome.agents_busy": "Operadores ocupados",
  "analytics.outcome.no_handoff_target": "Sem caixa de operadores configurada",
  "analytics.outcome.error": "Erro na transferência",
  "analytics.hours.in": "Dentro do horário",
  "analytics.hours.out": "Fora do horário",
  analyticsOperatorReply: "Tempo até o operador responder",
  analyticsOperatorReplyNote: "Medido quando o cliente recebeu a resposta, e não quando o operador a escreveu. Conversas ainda à espera: {waiting}.",
  "analytics.bucket.0-1m": "Menos de 1 min",
  "analytics.bucket.1-5m": "1 a 5 min",
  "analytics.bucket.5-15m": "5 a 15 min",
  "analytics.bucket.15-60m": "15 a 60 min",
  "analytics.bucket.60m+": "Mais de 1 hora",
  "analytics.bucket.none": "Sem resposta",
  analyticsSuggestions: "Sugestões por contexto de página",
  analyticsSuggestionsNote: "Inclui as sugestões que ninguém usou neste período.",
  analyticsWelcomeContext: "Ecrã de boas-vindas",
  analyticsUnnamedContext: "Contexto de página sem nome",
  analyticsDeletedContext: "Contexto apagado",
  analyticsSuggestion: "Sugestão",
  analyticsUses: "Utilizações",
  analyticsNotMeasured: "Não medida",
  analyticsNotMeasuredNote: "Utilizações não medidas, de sugestões demasiado longas para se contarem uma a uma (mais de 1024 bytes): {count}.",
  analyticsNoLongerConfigured: "já não configurada",
  analyticsMoreContexts: "Mostrar mais contextos ({shown} de {total})",
  analyticsNeverUsed: "Nunca usada",
  analyticsShowAllQuestions: "Mostrar as {count}",
  analyticsShowFewerQuestions: "Mostrar menos",
  analyticsRetry: "Tentar de novo",
  analyticsTopProducts: "Produtos mais mostrados",
  analyticsTopCards: "Cartões mais mostrados",
  analyticsTopProductsLimited: "Aqui estão os {count} mais mostrados; o Exportar (Conteúdo e assistente) traz todos.",
  analyticsTopProductsLead: "{products} produtos diferentes mostrados em cartões.",
  analyticsTopProductsLeadOne: "1 produto mostrado em cartões.",
  analyticsTopCurated: "Cartões curados mais mostrados",
  analyticsTopCuratedLead: "O mais mostrado foi {title}, {count} vezes.",
  analyticsTopCuratedLeadOne: "O mais mostrado foi {title}, 1 vez.",
  analyticsCardsShownNote: "Só as conversas de clientes, sem bots. Um cartão conta na hora em que se mostrou, e um clique ou um pedido de carrinho na hora em que aconteceu. O funil acima conta os cartões quando o assistente os envia, por isso os totais podem diferir um pouco.",
  analyticsCardsShownNoteNoCart: "Só as conversas de clientes, sem bots. Um cartão conta na hora em que se mostrou, e um clique na hora em que aconteceu. O funil acima conta os cartões quando o assistente os envia, por isso os totais podem diferir um pouco.",
  analyticsClicksSinceNoCart: "Os cliques contam desde {date}.",
  analyticsClicksSince: "Os cliques e os pedidos de carrinho contam desde {date}.",
  analyticsClicksNotRecorded: "Este chat ainda não registou cliques.",
  analyticsNoCardsShown: "Nenhum cartão mostrado neste período.",
  analyticsProduct: "Produto",
  analyticsCuratedCard: "Cartão",
  analyticsScope: "Âmbito",
  analyticsShownColumn: "Mostrado",
  analyticsClicksColumn: "Cliques",
  analyticsCartColumn: "Carrinho",
  analyticsNeverShown: "Nunca mostrado",
  analyticsCardNoLongerConfigured: "já não está na configuração",
  analyticsShowAllCards: "Mostrar os {count}",
  analyticsShowFewerCards: "Mostrar menos",
  analyticsChoices: "Escolhas guiadas",
  analyticsChoicesNote: "Só contam as perguntas feitas com opções para tocar. A opção tocada é exata. Uma resposta escrita não se lê, por isso não diz a que opção se referia.",
  analyticsChoicesFlow: "Conversas que chegaram a cada pergunta: {scope}",
  analyticsChoicesFlowNoScope: "Conversas que chegaram a cada pergunta: sem âmbito",
  analyticsChoicesAnsweredLabel: "responderam a {name}",
  analyticsChoicesAnsweredColumn: "Responderam à pergunta anterior",
  analyticsChoicesAsked: "Feita {count} vezes",
  analyticsChoicesAskedOne: "Feita 1 vez",
  analyticsChoicesNotAsked: "Não se fez neste período.",
  analyticsChoicesOptions: "Opções tocadas em {name}",
  analyticsChoicesNoQuestions: "Nenhuma pergunta feita com opções para tocar neste período.",
  analyticsChoicesReached: "Chegou a {count} conversas",
  analyticsChoicesReachedOne: "Chegou a 1 conversa",
  analyticsChoicesAnswered: "{count} responderam",
  analyticsChoicesAnsweredOne: "1 respondeu",
  analyticsChoicesUnknownOption: "Opção por identificar",
  "analyticsChoicesAnswer.tapped": "Tocaram numa opção",
  "analyticsChoicesAnswer.typed_reply": "Responderam sem tocar",
  "analyticsChoicesAnswer.no_reply": "Não responderam",
  "analyticsChoicesAnswer.open": "Conversa ainda aberta",
  analyticsToolsUsed: "Ferramentas usadas",
  analyticsToolsLead: "{calls} chamadas a ferramentas, das quais {share} falharam.",
  analyticsToolsLeadOne: "1 chamada a uma ferramenta.",
  analyticsToolsLeadOneFailed: "1 chamada a uma ferramenta, que falhou.",
  analyticsToolsLeadNoFailures: "{calls} chamadas a ferramentas, nenhuma falhou.",
  analyticsToolsNote: "Uma chamada falhou quando a ferramenta deu erro ou não acabou; a que responde que não encontrou nada não falhou. As chamadas de uma resposta que falhou antes da primeira mensagem não contam. O tempo típico é a mediana.",
  analyticsNoToolCalls: "O assistente não usou ferramentas neste período.",
  analyticsTool: "Ferramenta",
  analyticsCallsColumn: "Vezes",
  analyticsFailedColumn: "Falharam",
  analyticsTypicalTime: "Tempo típico",
  "analyticsTool.general_information_tool": "Pesquisar informação geral",
  "analyticsTool.campaigns_search_tool": "Pesquisar campanhas",
  "analyticsTool.product_recommendation_tool": "Pesquisar produtos",
  "analyticsTool.product_details_tool": "Ver os detalhes de um produto",
  "analyticsTool.send_product_cards_tool": "Mostrar cartões de produto",
  "analyticsTool.send_curated_cards_tool": "Mostrar cartões curados",
  "analyticsTool.send_choice_options_tool": "Mostrar opções de escolha",
  "analyticsTool.save_customer_preference_tool": "Guardar as preferências do cliente",
  "analyticsTool.human_handoff_tool": "Passar a um operador",
  "analyticsTool.order_inquiry_tool.lookup": "Consultar encomendas",
  "analyticsTool.order_inquiry_tool.faq": "Responder sobre encomendas",
  "analyticsTool.return_inquiry_tool": "Consultar devoluções",
  "analyticsTool.returnable_items_tool": "Ver os artigos que se podem devolver",
  "analyticsTool.store_stock_tool": "Ver o stock nas lojas",
  "analyticsTool.warehouse_stock_tool": "Ver o stock no armazém",
  "analyticsTool.send_end_conversation_button_tool": "Oferecer terminar a conversa",
  "analyticsTool.internal_procedures_tool": "Pesquisar procedimentos internos",
  analyticsTypedQuestions: "Perguntas escritas mais frequentes",
  analyticsTypedQuestionsNote: "A primeira mensagem de cada conversa, mostrada só quando {count} ou mais pessoas diferentes a fizeram. Segue a retenção das conversas.",
  analyticsLimitedByRetention: "As conversas guardam-se {days} dias, por isso esta lista só cobre essa parte do período.",
  analyticsLimitedByRetentionOneDay: "As conversas guardam-se 1 dia, por isso esta lista só cobre essa parte do período.",
  analyticsNoTypedQuestions: "Nenhuma pergunta chegou a {count} pessoas diferentes neste período.",
  analyticsQuestion: "Pergunta",
  analyticsLinks: "Ligações",
  analyticsConversationCount: "Conversas",
  analyticsContactCount: "Pessoas",
  analyticsOpenConversations: "Ver conversas ({count})",
  analyticsViewConversations: "Ver conversas",
  analyticsCsatViewOperatorConversations: "Ver conversas de {name}",
  analyticsRecentConversations: "As {count} conversas mais recentes",
  analyticsRecentConversation: "A conversa mais recente",
  analyticsCardsShown: "Produtos mostrados em cartões",
  analyticsCardClicks: "Cliques em cartões",
  analyticsAddToCart: "Adições ao carrinho pedidas",
  analyticsAddToCartNote: "As adições ao carrinho são os pedidos que o assistente enviou à página; a página não nos diz se o produto entrou no carrinho.",
  "analyticsOrderInquiries.lookup": "Encomendas consultadas por resultado",
  "analyticsOrderInquiries.faq": "Perguntas sobre encomendas por resultado",
  "analytics.order_outcome.found": "Encontrada",
  "analytics.order_outcome.found_delivered": "Encontrada, entregue",
  "analytics.order_outcome.found_in_transit": "Encontrada, em trânsito",
  "analytics.order_outcome.found_cancelled": "Encontrada, cancelada",
  "analytics.order_outcome.found_other": "Encontrada, outro estado",
  "analytics.order_outcome.not_found": "Não encontrada",
  "analytics.order_outcome.no_orders": "Sem encomendas",
  "analytics.order_outcome.not_authenticated": "Cliente sem sessão iniciada",
  "analytics.order_outcome.missing_order_id": "Sem número de encomenda",
  "analytics.order_outcome.ownership_mismatch": "Encomenda de outro cliente",
  "analytics.order_outcome.asked_for_clarification": "Pediu detalhes",
  "analytics.order_outcome.info_returned": "Informação devolvida",
  "analytics.order_outcome.fallback": "Mensagem padrão, sem informação encontrada",
  "analytics.order_outcome.no_strategy": "Consulta de encomendas não configurada",
  "analytics.order_outcome.error": "Erro",
  analyticsCampaignSearches: "Pesquisas de campanha",
  analyticsCampaignSearchesNote: "Sem resultado quer dizer que nenhuma campanha ficou perto do que foi pedido, e não que a campanha não existe.",
  "analytics.matched.true": "Com resultado",
  "analytics.matched.false": "Sem resultado",
  analyticsWhen: "Quando",
  analyticsDevicesNote: "Um iPad no Safari conta como computador nas visualizações e como tablet nas conversas.",
  analyticsConversationsLanguage: "Conversas por língua da página",
  "analytics.device.mobile": "Telemóvel",
  "analytics.device.desktop": "Computador",
  "analytics.device.tablet": "Tablet",
  "analytics.device.other": "Outro",
  "analytics.os.other": "Outro",
  "analytics.browser.other": "Outro",
  "analytics.language.pt": "Português",
  "analytics.language.en": "Inglês",
  "analytics.language.es": "Espanhol",
  "analytics.language.fr": "Francês",
  "analytics.language.de": "Alemão",
  "analytics.language.it": "Italiano",
  analyticsTechnical: "Camada técnica (Kodly)",
  analyticsTechnicalNotes: "O que cada número conta: uma visualização é um carregamento completo da página, por isso numa aplicação de página única conta menos do que as páginas vistas. As aberturas só se registam desde a versão que as mede, e antes dela as aberturas de visitantes com sessão iniciada não se mediam de todo.",
  analyticsJobsOnTime: "Contadores e conversas em dia.",
  analyticsCountersLate: "Os contadores não são escritos há mais de 5 minutos.",
  analyticsConversationsLate: "Os números das conversas não são recalculados há mais de 35 minutos.",
  analyticsAutoCloseSettings: "Fecho automático na fase do bot: {bot}. Na fase humana: {human}. As horas assentam ao fim de {frozen} horas.",
  analyticsAutoCloseOn: "ligado, ao fim de {hours} h",
  analyticsAutoCloseOff: "desligado",
  "analytics.warning.bot_auto_close_off": "O fecho automático está desligado na fase do bot: as conversas ficam abertas e a página conta menos do que houve.",
  "analytics.warning.bot_window_above_limit": "A janela da fase do bot é maior do que as horas em que os números assentam: as conversas ficam congeladas como abertas.",
  "analytics.warning.human_auto_close_off": "O fecho automático está desligado na fase humana, e este chat teve conversas com operador.",
  "analytics.warning.human_window_above_limit": "A janela da fase humana é maior do que as horas em que os números assentam.",
  analyticsBots: "Visualizações de bots",
  analyticsBotOpens: "Aberturas de bots",
  analyticsBotConversations: "Conversas de bots",
  analyticsRestoreOpens: "Assistente que voltou a abrir na página seguinte",
  analyticsDockedOpens: "Aberturas de um chat embutido",
  analyticsSearchResults: "Produtos encontrados pela pesquisa",
  analyticsFallbackReplies: "Turnos falhados (mensagem de erro enviada)",
  analyticsFallbackRepliesNote: "Turnos em que o assistente não conseguiu responder e foi enviada a mensagem de erro configurada, por exemplo quando o áudio não estava disponível ou faltava uma configuração. Não é o assistente a dizer que não sabe.",
  analyticsPageViewsBrowser: "Visualizações por browser",
  analyticsPageViewsOrigin: "Visualizações por origem",
  analyticsOriginNote: "As aberturas não têm origem: dividir as aberturas pelas visualizações de uma origem põe os ambientes de teste no numerador.",
  analyticsOpensBrowser: "Aberturas por browser",
  analyticsConversationsBrowser: "Conversas por browser e versão",
  analyticsConversationsOsVersion: "Conversas por sistema e versão",
  analyticsConversationsOrigin: "Conversas por origem da loja",
  analyticsReplyLatency: "Tempo até à primeira resposta",
  analyticsReplyLatencyDistribution: "Tempo até à primeira resposta, por intervalo",
  analyticsLatencyMedian: "Tempo até à primeira resposta (mediana)",
  analyticsLatencyP90: "Tempo até à primeira resposta (p90)",
  analyticsLatencyReplies: "{count} respostas medidas",
  analyticsLatencyRepliesOne: "1 resposta medida",
  analyticsLatencyP90Context: "90% das respostas chegaram em menos tempo",
  analyticsLatencyEvolution: "Tempo até à primeira resposta, dia a dia",
  analyticsLatencyEvolutionByHour: "Tempo até à primeira resposta, hora a hora",
  analyticsMedian: "Mediana",
  analyticsP90: "p90",
  analyticsLatencyUnder: "Menos de {to} s",
  analyticsLatencyRange: "{from} a {to} s",
  analyticsLatencyOver: "Mais de {from} s",
  analyticsSecondsOrMore: "{value} s ou mais",
  analyticsVoiceTitle: "Mensagens de voz",
  analyticsVoiceFigures: "Números das mensagens de voz",
  analyticsVoiceConversations: "Conversas com mensagem de voz",
  analyticsVoiceConversationsShare: "{pct}% das conversas",
  analyticsVoiceMedian: "Duração mediana",
  analyticsVoiceMeasured: "{count} medidas",
  analyticsVoiceMeasuredOne: "1 medida",
  analyticsVoiceDistribution: "Duração das mensagens de voz",
  analyticsVoiceInfo: "A duração e as mensagens que não chegaram ao assistente só existem desde a versão que as mede.",
  analyticsVoiceFailures: "Mensagens de voz que não chegaram ao assistente",
  analyticsVoiceFailuresDetail: "{pct}% das que foram ao assistente",
  analyticsVoiceFailureReasons: "Porque não chegaram",
  analyticsVoiceFailuresNote: "Também contam nos turnos falhados quando o chat tem a mensagem de áudio indisponível.",
  "analytics.voice_outcome.failed_fetch": "Não foi possível ler o áudio",
  "analytics.voice_outcome.rejected_format": "Formato não aceite",
  "analytics.voice_outcome.failed_normalize": "Não foi possível converter o áudio",
  analyticsCountersUpdated: "Contadores atualizados a {date}.",
  analyticsCountersNotUpdated: "Contadores ainda sem atualização.",
  analyticsConversationsUpdated: "Números das conversas atualizados a {date}.",
  analyticsConversationsNotUpdated: "Números das conversas ainda sem atualização.",
  analyticsDataSince: "Dados desde {date}.",
  analyticsPrecision: "As contagens podem ficar ligeiramente abaixo do real se a cache perder contadores por falta de memória.",
  "analyticsOpenRate": "Taxa de abertura",
  "analyticsKpiPreviousAndPerDay": "{previous} no período anterior · {perDay} por dia",
  "analyticsKpiPrevious": "{previous} no período anterior",
  "analyticsKpiOpenCount": "{count} aberturas",
  "analyticsKpiOpenCountOne": "1 abertura",
  "analyticsKpiPageViewCount": "{count} visualizações",
  "analyticsKpiPageViewCountOne": "1 visualização",
  "analyticsLessThan": "menos de {value}",
  "analyticsMissedInHoursNoteOne": "{share} do único pedido feito em horário de serviço",
  "analyticsHighlight.noOperatorInHoursOne": "pedido de operador em horário de serviço ficou sem ninguém disponível.",
  "analyticsKpiOpenRateContext": "{opens} em {views}",
  "analyticsKpiWithOperatorContext": "{count} conversas chegaram a um operador",
  "analyticsKpiWithOperatorContextOne": "1 conversa chegou a um operador",
  "analyticsKpiConversationCount": "{count} conversas",
  "analyticsKpiConversationCountOne": "1 conversa",
  "analyticsMostTypedQuestion": "Pergunta escrita mais frequente",
  "analyticsMostUsedSuggestion": "Sugestão mais usada",
  "analyticsNeverUsedSuggestions": "Sugestões nunca usadas",
  "analyticsKpiUses": "{count} utilizações",
  "analyticsKpiUsesOne": "1 utilização",
  "analyticsHighlights": "Destaques",
  "analyticsHighlight.noOperatorInHours": "pedidos de operador em horário de serviço ficaram sem ninguém disponível.",
  "analyticsHighlight.handoffPeakOutsideHours": "é a hora com mais pedidos de operador ({count}), fora do horário de serviço.",
  "analyticsHighlight.campaignsWithoutResult": "das pesquisas de campanha não encontraram campanha ({count} de {total}).",
  "analyticsHighlight.unusedSuggestion": "usos da sugestão «{label}» neste período.",
  "analyticsHighlight.unusedSuggestions": "sugestões configuradas não tiveram nenhum uso neste período.",
  "analyticsHighlight.conversationsChange": "de conversas face ao período anterior.",
  "analyticsHighlight.peakDay": "conversas a {day}, o dia com mais conversas do período.",
  "analyticsGoTo.overview": "Ver a evolução",
  "analyticsGoTo.conversations": "Ir para Conversas",
  "analyticsGoTo.assistant": "Ir para Assistente",
  "analyticsGoTo.content": "Ir para Conteúdo",
  "analyticsFunnelRate.opens": "abrem o assistente",
  "analyticsFunnelRate.conversations": "começam conversa",
  "analyticsFunnelRate.two_or_more": "continuam",
  "analyticsFunnelRateColumn": "Parte do passo anterior",
  "analyticsEvolution": "Evolução",
  "analyticsMetric": "Métrica",
  "analyticsOpens": "Aberturas",
  "analyticsHandoffRequests": "Pedidos de operador",
  "analyticsDay": "Dia",
  "analyticsHour": "Hora",
  "analyticsCurrentPeriod": "Este período",
  "analyticsPreviousPeriodShort": "Período anterior",
  "analyticsYesterday": "Ontem",
  "analyticsToday": "Hoje",
  "analyticsPreviousDay": "Dia anterior",
  "analyticsUntilTime": "{label} até às {time}",
  "analyticsPreviousPeriodDay": "Dia do período anterior",
  "analyticsPreviousPeriodHour": "Hora do período anterior",
  "analyticsPeak": "Máximo: {day}, {value}",
  "analyticsTodayPartial": "O último dia ainda está a decorrer.",
  "analyticsHourPartial": "A barra mais ténue é a hora que ainda está a decorrer.",
  "analyticsHourStillGoing": "a decorrer",
  "analyticsStarts": "Como começam",
  "analyticsStartsLead": "{typed}% começam com texto escrito e {suggestion}% numa sugestão.",
  "analyticsStartsLeadWithVoice": "{typed}% começam com texto escrito, {suggestion}% numa sugestão e {voice}% numa mensagem de voz.",
  "analyticsCompositionTitle": "Como se escrevem",
  "analyticsEndingsTitle": "Como acabam",
  "analyticsCustomerProfile": "Perfil do cliente",
  "analyticsCustomerProfileNote": "O perfil vem do cookie de identidade do site. Uma conversa conta como reconhecida quando o assistente teve o perfil do cliente em pelo menos uma mensagem. Nas conversas mais antigas o estado não ficou registado.",
  "analyticsConversationsByProfile": "Conversas por perfil",
  "analyticsProfileLead": "{share}% das conversas tinham o perfil do cliente.",
  "analyticsSizeSearches": "Pesquisas por tamanho",
  "analyticsSizeSearchesLead": "Em {share}% das pesquisas por tamanho o assistente pediu os tamanhos ao cliente.",
  "analyticsSizeSearchesNote": "Conta cada pesquisa que o assistente fez, também as de uma tentativa que ele repetiu depois de um erro.",
  "analyticsDayByDay": "Dia a dia",
  "analyticsHourByHour": "Hora a hora",
  "analyticsHowTheyClosed": "Como se fecharam",
  "analyticsEndingsLeadNoOperator": "{inactivity}% fecharam-se sozinhas por inatividade e {customer}% foram fechadas pelo cliente.",
  "analyticsEndingsLead": "{inactivity}% fecharam-se sozinhas por inatividade, {customer}% foram fechadas pelo cliente e {operator}% por um operador.",
  "analyticsOperators": "Operadores",
  "analyticsConversationsStarted": "Conversas iniciadas",
  "analyticsHowTheyStartAndWrite": "Como começam e como se escrevem",
  "analyticsOperatorsEvolution": "Pedidos e pedidos atendidos",
  "analyticsOperatorServed": "Atendidos por um operador",
  "analyticsShareOfRequests": "{share} dos pedidos de operador",
  "analyticsMissedInHours": "Em horário, sem ninguém disponível",
  "analyticsMissedInHoursNote": "{share} dos {count} pedidos feitos em horário de serviço",
  "analyticsHandoffOutcomeTitle": "O que aconteceu aos pedidos",
  "analyticsHoursIn": "Em horário de serviço: {count}",
  "analyticsHoursOut": "Fora do horário: {count}",
  "analyticsHoursUnattributed": "Sem informação: {count}",
  "analyticsReplyTimeLead": "{share} das conversas com operador tiveram resposta em menos de 5 minutos.",
  "analyticsWhenLead": "O dia com mais {noun} é {day} ({dayCount}), e a hora de pico é às {hour}h ({hourCount}).",
  "analyticsWhenLeadOutside": "O dia com mais {noun} é {day} ({dayCount}), e a hora de pico é às {hour}h ({hourCount}), já fora do horário de serviço.",
  "analyticsWhenLeadHour": "A hora com mais {noun} é às {hour}h ({hourCount}).",
  "analyticsWhenLeadHourOutside": "A hora com mais {noun} é às {hour}h ({hourCount}), já fora do horário de serviço.",
  "analyticsWhenNoun.conversations": "conversas",
  "analyticsWhenNoun.handoff_requests": "pedidos de operador",
  "analyticsWhenShow": "Mostrar",
  "analyticsByWeekday": "Por dia da semana",
  "analyticsByHour": "Por hora do dia",
  "analyticsServiceHours": "Horário de serviço: {days}, {start}h às {end}h",
  "analyticsDaysRange": "{from} a {to}",
  "analyticsDeviceTitle": "Dispositivo",
  "analyticsSystemTitle": "Sistema",
  "analyticsAudience.page_views": "Visualizações",
  "analyticsAudience.conversations": "Conversas",
  "analyticsCardsTitle": "Cartões de produto",
  "analyticsPer100CardsColumn": "Por 100 cartões",
  "analyticsTab.overview": "Visão geral",
  "analyticsTab.adoption": "Adoção",
  "analyticsTab.conversations": "Conversas",
  "analyticsTab.content": "Conteúdo",
  "analyticsTab.assistant": "Assistente",
  "analyticsTab.technical": "Técnica",
  "analyticsSections": "Secções da analytics",
  "analyticsComparedWithShort": "Comparado com {from} a {to}",
  "analyticsComparedWithYesterday": "Comparado com ontem",
  "analyticsComparedWithYesterdayUntil": "Comparado com ontem até às {time}",
  "analyticsComparedWithUntil": "Comparado com {from} a {to} até às {time}",
  "analyticsComparedWithDay": "Comparado com {day}",
  "analyticsCutNote": "Os números das conversas, das aberturas e dos cliques comparam-se até ao último recálculo, às {time}.",
  "analyticsCutNoteOtherDay": "Os números das conversas, das aberturas e dos cliques comparam-se até ao último recálculo, a {day} às {time}.",
  "analyticsNoComparisonBefore": "Sem comparação: os dados começam a {date}",
  "analyticsAboutPeriod": "Sobre o período",
  "analyticsNoDataYet": "Ainda não há dados para este chat.",
  "analyticsNoDataBefore": "Ainda não há dados neste período. Os dados começam a {date}.",
  "analyticsShowSince": "Ver desde {date}",
  "analyticsKpiInvitesShown": "{shown} convite{plural} mostrado{plural}",
  "analyticsWhereTheyOpen": "De onde abrem",
  "analyticsOpensLead": "{share}% das aberturas vêm do botão do assistente.",
  "analyticsWhoTheyAre": "Quem são",
  "analyticsClicksPer100": "Cliques por 100 cartões",
  "analyticsCartPer100": "Carrinho por 100 cartões",
  "analyticsCampaignsWithoutResult": "Pesquisas de campanha sem resultado",
  "analyticsOrderInquiriesCount.lookup": "Encomendas consultadas",
  "analyticsOrderInquiriesCount.faq": "Perguntas sobre encomendas",
  "analyticsKpiClicks": "{clicks} clique{plural}",
  "analyticsKpiCartRequests": "{requests} pedido{plural} de carrinho",
  "analyticsKpiCampaignSearches": "{without} de {total} pesquisas",
  "analyticsKpiCampaignSearchesOne": "{without} de {total} pesquisa",
  "analyticsPer100CardsLabel": "por 100 cartões",
  "analyticsCardsToCart": "Dos cartões ao carrinho",
  "analyticsCardsToCartLead": "{clicks} cliques e {carts} pedidos de carrinho por cada 100 cartões.",
  "analyticsCardsAndClicks": "Cartões e cliques",
  "analyticsCardsLead": "{clicks} cliques por cada 100 cartões.",
  "analyticsOrders": "Encomendas",
  "analyticsCampaigns": "Campanhas",
  "analyticsCampaignsLead": "{share} das pesquisas de campanha não encontraram campanha.",
  "analyticsOrdersAndCampaigns": "Encomendas e campanhas",
  "analyticsOrdersAndCampaignsLead.lookup": "{orders} encomendas consultadas; {share} das pesquisas de campanha não encontraram campanha.",
  "analyticsOrdersAndCampaignsLead.faq": "{orders} perguntas sobre encomendas; {share} das pesquisas de campanha não encontraram campanha.",
  "analyticsOrdersAndCampaignsLeadOne.lookup": "1 encomenda consultada; {share} das pesquisas de campanha não encontraram campanha.",
  "analyticsOrdersAndCampaignsLeadOne.faq": "1 pergunta sobre encomendas; {share} das pesquisas de campanha não encontraram campanha.",
  "analyticsOrdersLead.lookup": "{orders} encomendas consultadas.",
  "analyticsOrdersLead.faq": "{orders} perguntas sobre encomendas.",
  "analyticsOrdersLeadOne.lookup": "1 encomenda consultada.",
  "analyticsOrdersLeadOne.faq": "1 pergunta sobre encomendas.",
  "analyticsCsatTitle": "Avaliação do cliente",
  "analyticsCsatNumbers": "Avaliação do cliente em números",
  "analyticsCsatNote": "Avaliações das conversas fechadas no período. Cada uma conta no dia em que a conversa fechou, mesmo que chegue depois, por isso os dias mais recentes ainda podem receber avaliações.",
  "analyticsCsatNoRequests": "Sem pedidos de avaliação no período.",
  "analyticsCsatTurnedOff": "O pedido de avaliação foi desligado neste chat. Os números são dos pedidos feitos antes.",
  "analyticsCsatResponseRate": "Taxa de resposta",
  "analyticsCsatResponseRateContext": "{ratings} em {requested}",
  "analyticsCsatRatingCount": "{count} avaliações",
  "analyticsCsatRatingCountOne": "1 avaliação",
  "analyticsCsatRequestCount": "{count} pedidos",
  "analyticsCsatRequestCountOne": "1 pedido",
  "analyticsCsatSatisfaction": "Satisfação",
  "analyticsCsatSatisfactionContext": "Avaliações de 4 e 5 estrelas",
  "analyticsCsatAverage": "Média",
  "analyticsCsatAverageValue": "{value} de 5",
  "analyticsCsatAverageContext": "em {ratings}",
  "analyticsCsatWithComment": "Com comentário",
  "analyticsCsatWithCommentContext": "{share} das avaliações",
  "analyticsCsatWithCommentNote": "O comentário lê-se na conversa, para quem a pode abrir.",
  "analyticsCsatDistribution": "Distribuição pelas estrelas",
  "analyticsCsatSeeByStars": "Ver as conversas com",
  "analytics.rating.1": "1 estrela",
  "analytics.rating.2": "2 estrelas",
  "analytics.rating.3": "3 estrelas",
  "analytics.rating.4": "4 estrelas",
  "analytics.rating.5": "5 estrelas",
  "analyticsCsatRatingsFrom": "Avaliações de",
  "analyticsCsatGroup.all": "Todas",
  "analyticsCsatGroup.with_operator": "Com operador",
  "analyticsCsatGroup.assistant_only": "Só com o assistente",
  "analyticsCsatGroups": "Com operador e só com o assistente",
  "analyticsCsatRequests": "Pedidos",
  "analyticsCsatRatings": "Avaliações",
  "analyticsCsatByOperator": "Por operador",
  "analyticsCsatOperator": "Operador",
  "analyticsCsatByOperatorNote": "Ordenado pelo número de avaliações: uma amostra pequena não é uma classificação do operador.",
  "analyticsCsatByOperatorEmpty": "Nenhuma conversa com operador foi avaliada neste período.",
  "analyticsCsatAssistantOnlyNote": "Com o assistente, o pedido só sai quando o próprio cliente termina a conversa: estas avaliações são de quem a terminou de propósito.",
  "analyticsSignedIn": "Sessão iniciada",
  "analyticsSessionsLead": "{share}% das conversas foram de clientes com sessão iniciada.",
  "analyticsSignedInConversations": "Conversas com sessão iniciada",
  "analyticsSignedInCustomers": "Clientes com sessão iniciada",
  "analyticsSignedInCustomersNote": "Cada cliente conta uma vez no período, tenha as conversas que tiver.",
  "analyticsSignedInCustomersRetention": "Só as conversas guardadas: a retenção apaga as de mais de {days} dias.",
  "analyticsSignedInCustomersRetentionOneDay": "Só as conversas guardadas: a retenção apaga as de mais de 1 dia.",
  "analyticsSignedInCustomersNoPrevious": "O período anterior já não está guardado: a retenção apaga as conversas de mais de {days} dias.",
  "analyticsSignedInCustomersNoPreviousOneDay": "O período anterior já não está guardado: a retenção apaga as conversas de mais de 1 dia.",
  "analyticsSignedInNumbers": "Sessão iniciada em números",
  "analyticsSignInTitle": "Quando iniciaram sessão",
  "analyticsSignInNote": "Durante a conversa é o cliente que inicia sessão com a conversa aberta. Uma conversa que fechou anónima fica anónima, mesmo que o cliente inicie sessão depois.",
  "analyticsSignInBefore": "{count} conversas deste período são de antes do registo da sessão, que começou a {date}, e não entram aqui: delas só se sabe se o cliente tem sessão hoje.",
  "analyticsSignInBeforeOne": "1 conversa deste período é de antes do registo da sessão, que começou a {date}, e não entra aqui: dela só se sabe se o cliente tem sessão hoje.",
  "analyticsSignInBeforeAll": "As conversas deste período são de antes do registo da sessão: delas só se sabe se o cliente tem sessão hoje.",
  "analyticsSignedInEvolution": "Evolução das conversas com sessão iniciada",
  "analyticsSignedInShare": "Com sessão iniciada",
  "analytics.sign_in.at_start": "Desde o início",
  "analytics.sign_in.during": "Durante a conversa",
  "analytics.sign_in.anonymous": "Anónimas",
  "analyticsPagesTitle": "Páginas com mais conversas",
  "analyticsPagesLead": "{share}% das conversas começaram nas {count} páginas com mais conversas.",
  "analyticsPagesLeadOne": "{share}% das conversas começaram na página com mais conversas.",
  "analyticsPagesStart": "Onde começaram",
  "analyticsPagesThrough": "Por onde passaram",
  "analyticsPagesOthers": "Outras páginas",
  "analyticsPagesWithout": "Sem página",
  "analyticsPagesNote": "O caminho da página, sem parâmetros. Números e códigos longos aparecem como :id, e emails como :email. Sem página são as conversas em que o cliente só mandou voz ou imagens, ou escreveu de fora do site.",
  "analyticsPagesThroughNote": "Uma conversa conta em cada página de onde o cliente escreveu, por isso as percentagens não somam 100%.",
  "analyticsPagesSince": "Os dados das páginas começam a {date}.",
  "analyticsPagesShareColumn": "Percentagem das conversas",
};
